var map = {
	"./": [
		43181,
		9
	],
	"./@types/react-i18next/index.d": [
		33174,
		9,
		33174
	],
	"./@types/react-i18next/index.d.ts": [
		33174,
		9,
		33174
	],
	"./App.css": [
		44050,
		9,
		44050
	],
	"./assets/css/base.min.css": [
		48200,
		9,
		48200
	],
	"./assets/css/main.css": [
		1762,
		9
	],
	"./assets/css/tailwind_manual.css": [
		67100,
		9,
		67100
	],
	"./assets/geojson/communes/00001-01101.geojson": [
		20292,
		1,
		20292
	],
	"./assets/geojson/communes/00001-01107.geojson": [
		58506,
		1,
		36125
	],
	"./assets/geojson/communes/00001-01401.geojson": [
		53397,
		1,
		53397
	],
	"./assets/geojson/communes/00001-01402.geojson": [
		35733,
		1,
		58114
	],
	"./assets/geojson/communes/00001-01403.geojson": [
		68631,
		1,
		68631
	],
	"./assets/geojson/communes/00001-01404.geojson": [
		2396,
		1,
		2396
	],
	"./assets/geojson/communes/00001-01405.geojson": [
		34465,
		1,
		34465
	],
	"./assets/geojson/communes/00001.geojson": [
		97968,
		1,
		97968
	],
	"./assets/geojson/communes/00002-02101.geojson": [
		76974,
		1,
		76974
	],
	"./assets/geojson/communes/00002-02102.geojson": [
		12593,
		1,
		12593
	],
	"./assets/geojson/communes/00002-02103.geojson": [
		77484,
		1,
		77484
	],
	"./assets/geojson/communes/00002-02104.geojson": [
		14759,
		1,
		14759
	],
	"./assets/geojson/communes/00002-02201.geojson": [
		23705,
		1,
		23705
	],
	"./assets/geojson/communes/00002-02202.geojson": [
		1910,
		1,
		1910
	],
	"./assets/geojson/communes/00002-02203.geojson": [
		2635,
		1,
		2635
	],
	"./assets/geojson/communes/00002-02301.geojson": [
		72572,
		1,
		72572
	],
	"./assets/geojson/communes/00002-02302.geojson": [
		10067,
		1,
		10067
	],
	"./assets/geojson/communes/00002.geojson": [
		22071,
		1,
		22071
	],
	"./assets/geojson/communes/00003-03101.geojson": [
		59420,
		1,
		59420
	],
	"./assets/geojson/communes/00003-03102.geojson": [
		72051,
		1,
		72051
	],
	"./assets/geojson/communes/00003-03103.geojson": [
		12254,
		1,
		12254
	],
	"./assets/geojson/communes/00003-03201.geojson": [
		86651,
		1,
		86651
	],
	"./assets/geojson/communes/00003-03202.geojson": [
		59556,
		1,
		59556
	],
	"./assets/geojson/communes/00003-03301.geojson": [
		67726,
		1,
		67726
	],
	"./assets/geojson/communes/00003-03302.geojson": [
		23057,
		1,
		23057
	],
	"./assets/geojson/communes/00003-03303.geojson": [
		22700,
		1,
		22700
	],
	"./assets/geojson/communes/00003-03304.geojson": [
		68295,
		1,
		68295
	],
	"./assets/geojson/communes/00003.geojson": [
		1570,
		1,
		1570
	],
	"./assets/geojson/communes/00004-04101.geojson": [
		28629,
		1,
		51010
	],
	"./assets/geojson/communes/00004-04102.geojson": [
		30037,
		1,
		30037
	],
	"./assets/geojson/communes/00004-04103.geojson": [
		49296,
		1,
		49296
	],
	"./assets/geojson/communes/00004-04104.geojson": [
		95571,
		1,
		95571
	],
	"./assets/geojson/communes/00004-04105.geojson": [
		52126,
		1,
		52126
	],
	"./assets/geojson/communes/00004-04106.geojson": [
		49985,
		1,
		49985
	],
	"./assets/geojson/communes/00004-04201.geojson": [
		97789,
		1,
		97789
	],
	"./assets/geojson/communes/00004-04202.geojson": [
		7594,
		1,
		7594
	],
	"./assets/geojson/communes/00004-04203.geojson": [
		3775,
		1,
		3775
	],
	"./assets/geojson/communes/00004-04204.geojson": [
		67108,
		1,
		67108
	],
	"./assets/geojson/communes/00004-04301.geojson": [
		20928,
		1,
		20928
	],
	"./assets/geojson/communes/00004-04302.geojson": [
		45863,
		1,
		45863
	],
	"./assets/geojson/communes/00004-04303.geojson": [
		34610,
		1,
		34610
	],
	"./assets/geojson/communes/00004-04304.geojson": [
		27345,
		1,
		27345
	],
	"./assets/geojson/communes/00004-04305.geojson": [
		8588,
		1,
		8588
	],
	"./assets/geojson/communes/00004.geojson": [
		15009,
		1,
		15009
	],
	"./assets/geojson/communes/00005-05101.geojson": [
		77708,
		1,
		77708
	],
	"./assets/geojson/communes/00005-05102.geojson": [
		97987,
		1,
		97987
	],
	"./assets/geojson/communes/00005-05103.geojson": [
		32942,
		1,
		32942
	],
	"./assets/geojson/communes/00005-05104.geojson": [
		36325,
		1,
		36325
	],
	"./assets/geojson/communes/00005-05105.geojson": [
		70912,
		1,
		70912
	],
	"./assets/geojson/communes/00005-05107.geojson": [
		73298,
		1,
		73298
	],
	"./assets/geojson/communes/00005-05109.geojson": [
		99060,
		1,
		99060
	],
	"./assets/geojson/communes/00005-05201.geojson": [
		68395,
		1,
		68395
	],
	"./assets/geojson/communes/00005-05301.geojson": [
		91358,
		1,
		91358
	],
	"./assets/geojson/communes/00005-05302.geojson": [
		17921,
		1,
		17921
	],
	"./assets/geojson/communes/00005-05303.geojson": [
		85852,
		1,
		85852
	],
	"./assets/geojson/communes/00005-05304.geojson": [
		52087,
		1,
		52087
	],
	"./assets/geojson/communes/00005-05401.geojson": [
		47805,
		1,
		47805
	],
	"./assets/geojson/communes/00005-05402.geojson": [
		57610,
		1,
		57610
	],
	"./assets/geojson/communes/00005-05403.geojson": [
		76172,
		1,
		53791
	],
	"./assets/geojson/communes/00005-05404.geojson": [
		17124,
		1,
		17124
	],
	"./assets/geojson/communes/00005-05405.geojson": [
		20681,
		1,
		20681
	],
	"./assets/geojson/communes/00005-05501.geojson": [
		70944,
		1,
		70944
	],
	"./assets/geojson/communes/00005-05502.geojson": [
		95879,
		1,
		95879
	],
	"./assets/geojson/communes/00005-05503.geojson": [
		84626,
		1,
		84626
	],
	"./assets/geojson/communes/00005-05504.geojson": [
		77361,
		1,
		77361
	],
	"./assets/geojson/communes/00005-05506.geojson": [
		4419,
		1,
		4419
	],
	"./assets/geojson/communes/00005-05601.geojson": [
		3055,
		1,
		3055
	],
	"./assets/geojson/communes/00005-05602.geojson": [
		31272,
		1,
		31272
	],
	"./assets/geojson/communes/00005-05603.geojson": [
		55149,
		1,
		55149
	],
	"./assets/geojson/communes/00005-05604.geojson": [
		24022,
		1,
		24022
	],
	"./assets/geojson/communes/00005-05605.geojson": [
		34347,
		1,
		34347
	],
	"./assets/geojson/communes/00005-05606.geojson": [
		67060,
		1,
		67060
	],
	"./assets/geojson/communes/00005-05701.geojson": [
		1026,
		1,
		1026
	],
	"./assets/geojson/communes/00005-05702.geojson": [
		80053,
		1,
		80053
	],
	"./assets/geojson/communes/00005-05703.geojson": [
		82960,
		1,
		82960
	],
	"./assets/geojson/communes/00005-05704.geojson": [
		45587,
		1,
		45587
	],
	"./assets/geojson/communes/00005-05705.geojson": [
		2142,
		1,
		2142
	],
	"./assets/geojson/communes/00005-05706.geojson": [
		1,
		1,
		1
	],
	"./assets/geojson/communes/00005-05801.geojson": [
		71537,
		1,
		71537
	],
	"./assets/geojson/communes/00005-05802.geojson": [
		16206,
		1,
		16206
	],
	"./assets/geojson/communes/00005-05803.geojson": [
		71139,
		1,
		71139
	],
	"./assets/geojson/communes/00005-05804.geojson": [
		73696,
		1,
		73696
	],
	"./assets/geojson/communes/00005.geojson": [
		86588,
		1,
		86588
	],
	"./assets/geojson/communes/00006-06101.geojson": [
		5462,
		1,
		5462
	],
	"./assets/geojson/communes/00006-06102.geojson": [
		43609,
		1,
		43609
	],
	"./assets/geojson/communes/00006-06103.geojson": [
		79252,
		1,
		79252
	],
	"./assets/geojson/communes/00006-06104.geojson": [
		82063,
		1,
		82063
	],
	"./assets/geojson/communes/00006-06105.geojson": [
		65306,
		1,
		65306
	],
	"./assets/geojson/communes/00006-06106.geojson": [
		38893,
		1,
		38893
	],
	"./assets/geojson/communes/00006-06107.geojson": [
		36552,
		1,
		36552
	],
	"./assets/geojson/communes/00006-06108.geojson": [
		78179,
		1,
		78179
	],
	"./assets/geojson/communes/00006-06109.geojson": [
		96782,
		1,
		96782
	],
	"./assets/geojson/communes/00006-06110.geojson": [
		63460,
		1,
		63460
	],
	"./assets/geojson/communes/00006-06111.geojson": [
		96009,
		1,
		96009
	],
	"./assets/geojson/communes/00006-06112.geojson": [
		22790,
		1,
		22790
	],
	"./assets/geojson/communes/00006-06113.geojson": [
		62075,
		1,
		62075
	],
	"./assets/geojson/communes/00006-06114.geojson": [
		18456,
		1,
		18456
	],
	"./assets/geojson/communes/00006-06115.geojson": [
		45181,
		1,
		45181
	],
	"./assets/geojson/communes/00006-06116.geojson": [
		37546,
		1,
		37546
	],
	"./assets/geojson/communes/00006-06117.geojson": [
		24543,
		1,
		24543
	],
	"./assets/geojson/communes/00006-06201.geojson": [
		7137,
		1,
		7137
	],
	"./assets/geojson/communes/00006-06202.geojson": [
		57982,
		1,
		57982
	],
	"./assets/geojson/communes/00006-06203.geojson": [
		60307,
		1,
		60307
	],
	"./assets/geojson/communes/00006-06204.geojson": [
		36176,
		1,
		36176
	],
	"./assets/geojson/communes/00006-06205.geojson": [
		83221,
		1,
		83221
	],
	"./assets/geojson/communes/00006-06206.geojson": [
		89698,
		1,
		89698
	],
	"./assets/geojson/communes/00006-06301.geojson": [
		81092,
		1,
		81092
	],
	"./assets/geojson/communes/00006-06302.geojson": [
		79707,
		1,
		79707
	],
	"./assets/geojson/communes/00006-06303.geojson": [
		40422,
		1,
		40422
	],
	"./assets/geojson/communes/00006-06304.geojson": [
		79165,
		1,
		79165
	],
	"./assets/geojson/communes/00006-06305.geojson": [
		36088,
		1,
		36088
	],
	"./assets/geojson/communes/00006-06306.geojson": [
		58527,
		1,
		58527
	],
	"./assets/geojson/communes/00006-06307.geojson": [
		55178,
		1,
		55178
	],
	"./assets/geojson/communes/00006-06308.geojson": [
		33185,
		1,
		33185
	],
	"./assets/geojson/communes/00006-06309.geojson": [
		98364,
		1,
		98364
	],
	"./assets/geojson/communes/00006-06310.geojson": [
		33658,
		1,
		33658
	],
	"./assets/geojson/communes/00006.geojson": [
		24083,
		1,
		24083
	],
	"./assets/geojson/communes/00007-07101.geojson": [
		1348,
		1,
		1348
	],
	"./assets/geojson/communes/00007-07102.geojson": [
		12283,
		1,
		12283
	],
	"./assets/geojson/communes/00007-07103.geojson": [
		80582,
		1,
		80582
	],
	"./assets/geojson/communes/00007-07104.geojson": [
		76413,
		1,
		76413
	],
	"./assets/geojson/communes/00007-07105.geojson": [
		88408,
		1,
		88408
	],
	"./assets/geojson/communes/00007-07106.geojson": [
		74655,
		1,
		74655
	],
	"./assets/geojson/communes/00007-07107.geojson": [
		9354,
		1,
		9354
	],
	"./assets/geojson/communes/00007-07108.geojson": [
		55425,
		1,
		55425
	],
	"./assets/geojson/communes/00007-07109.geojson": [
		23356,
		1,
		23356
	],
	"./assets/geojson/communes/00007-07110.geojson": [
		18970,
		1,
		18970
	],
	"./assets/geojson/communes/00007-07201.geojson": [
		94307,
		1,
		94307
	],
	"./assets/geojson/communes/00007-07202.geojson": [
		5420,
		1,
		5420
	],
	"./assets/geojson/communes/00007-07203.geojson": [
		20145,
		1,
		20145
	],
	"./assets/geojson/communes/00007-07301.geojson": [
		47542,
		1,
		47542
	],
	"./assets/geojson/communes/00007-07302.geojson": [
		53849,
		1,
		53849
	],
	"./assets/geojson/communes/00007-07303.geojson": [
		25076,
		1,
		25076
	],
	"./assets/geojson/communes/00007-07304.geojson": [
		86607,
		1,
		86607
	],
	"./assets/geojson/communes/00007-07305.geojson": [
		48058,
		1,
		48058
	],
	"./assets/geojson/communes/00007-07306.geojson": [
		20653,
		1,
		20653
	],
	"./assets/geojson/communes/00007-07307.geojson": [
		61832,
		1,
		61832
	],
	"./assets/geojson/communes/00007-07308.geojson": [
		20355,
		1,
		20355
	],
	"./assets/geojson/communes/00007-07309.geojson": [
		64142,
		1,
		64142
	],
	"./assets/geojson/communes/00007-07401.geojson": [
		89141,
		1,
		89141
	],
	"./assets/geojson/communes/00007-07402.geojson": [
		26466,
		1,
		26466
	],
	"./assets/geojson/communes/00007-07403.geojson": [
		32407,
		1,
		32407
	],
	"./assets/geojson/communes/00007-07404.geojson": [
		58396,
		1,
		58396
	],
	"./assets/geojson/communes/00007-07405.geojson": [
		25441,
		1,
		25441
	],
	"./assets/geojson/communes/00007-07406.geojson": [
		27582,
		1,
		27582
	],
	"./assets/geojson/communes/00007-07407.geojson": [
		71027,
		1,
		71027
	],
	"./assets/geojson/communes/00007-07408.geojson": [
		9624,
		1,
		9624
	],
	"./assets/geojson/communes/00007.geojson": [
		39134,
		1,
		39134
	],
	"./assets/geojson/communes/00008-08101.geojson": [
		14450,
		1,
		14450
	],
	"./assets/geojson/communes/00008-08102.geojson": [
		2885,
		1,
		2885
	],
	"./assets/geojson/communes/00008-08103.geojson": [
		37056,
		1,
		37056
	],
	"./assets/geojson/communes/00008-08104.geojson": [
		28003,
		1,
		28003
	],
	"./assets/geojson/communes/00008-08105.geojson": [
		71790,
		1,
		71790
	],
	"./assets/geojson/communes/00008-08106.geojson": [
		53841,
		1,
		53841
	],
	"./assets/geojson/communes/00008-08107.geojson": [
		55468,
		1,
		55468
	],
	"./assets/geojson/communes/00008-08108.geojson": [
		94255,
		1,
		94255
	],
	"./assets/geojson/communes/00008-08109.geojson": [
		55706,
		1,
		55706
	],
	"./assets/geojson/communes/00008-08110.geojson": [
		38736,
		1,
		38736
	],
	"./assets/geojson/communes/00008-08111.geojson": [
		62005,
		1,
		62005
	],
	"./assets/geojson/communes/00008-08112.geojson": [
		66722,
		1,
		66722
	],
	"./assets/geojson/communes/00008-08201.geojson": [
		29901,
		1,
		29901
	],
	"./assets/geojson/communes/00008-08202.geojson": [
		56314,
		1,
		56314
	],
	"./assets/geojson/communes/00008-08203.geojson": [
		73071,
		1,
		73071
	],
	"./assets/geojson/communes/00008-08204.geojson": [
		70260,
		1,
		70260
	],
	"./assets/geojson/communes/00008-08205.geojson": [
		34617,
		1,
		34617
	],
	"./assets/geojson/communes/00008-08206.geojson": [
		96470,
		1,
		96470
	],
	"./assets/geojson/communes/00008-08207.geojson": [
		97195,
		1,
		97195
	],
	"./assets/geojson/communes/00008-08301.geojson": [
		42384,
		1,
		42384
	],
	"./assets/geojson/communes/00008-08302.geojson": [
		80887,
		1,
		80887
	],
	"./assets/geojson/communes/00008-08303.geojson": [
		70370,
		1,
		70370
	],
	"./assets/geojson/communes/00008-08304.geojson": [
		63073,
		1,
		63073
	],
	"./assets/geojson/communes/00008-08305.geojson": [
		31004,
		1,
		31004
	],
	"./assets/geojson/communes/00008-08306.geojson": [
		91635,
		1,
		91635
	],
	"./assets/geojson/communes/00008-08307.geojson": [
		20158,
		1,
		20158
	],
	"./assets/geojson/communes/00008-08308.geojson": [
		84061,
		1,
		84061
	],
	"./assets/geojson/communes/00008-08309.geojson": [
		96056,
		1,
		96056
	],
	"./assets/geojson/communes/00008-08310.geojson": [
		39846,
		1,
		39846
	],
	"./assets/geojson/communes/00008-08311.geojson": [
		79131,
		1,
		79131
	],
	"./assets/geojson/communes/00008-08312.geojson": [
		80516,
		1,
		80516
	],
	"./assets/geojson/communes/00008-08313.geojson": [
		13065,
		1,
		13065
	],
	"./assets/geojson/communes/00008-08314.geojson": [
		54602,
		1,
		54602
	],
	"./assets/geojson/communes/00008.geojson": [
		24317,
		1,
		24317
	],
	"./assets/geojson/communes/00009-09101.geojson": [
		80884,
		1,
		80884
	],
	"./assets/geojson/communes/00009-09102.geojson": [
		24043,
		1,
		24043
	],
	"./assets/geojson/communes/00009-09103.geojson": [
		25718,
		1,
		25718
	],
	"./assets/geojson/communes/00009-09104.geojson": [
		61485,
		1,
		61485
	],
	"./assets/geojson/communes/00009-09105.geojson": [
		56264,
		1,
		56264
	],
	"./assets/geojson/communes/00009-09106.geojson": [
		73871,
		1,
		73871
	],
	"./assets/geojson/communes/00009-09107.geojson": [
		71258,
		1,
		71258
	],
	"./assets/geojson/communes/00009-09108.geojson": [
		17233,
		1,
		17233
	],
	"./assets/geojson/communes/00009-09109.geojson": [
		16876,
		1,
		16876
	],
	"./assets/geojson/communes/00009-09110.geojson": [
		31914,
		1,
		31914
	],
	"./assets/geojson/communes/00009-09111.geojson": [
		15967,
		1,
		15967
	],
	"./assets/geojson/communes/00009-09112.geojson": [
		87192,
		1,
		87192
	],
	"./assets/geojson/communes/00009-09113.geojson": [
		46493,
		1,
		46493
	],
	"./assets/geojson/communes/00009-09114.geojson": [
		18342,
		1,
		18342
	],
	"./assets/geojson/communes/00009-09115.geojson": [
		37147,
		1,
		37147
	],
	"./assets/geojson/communes/00009-09116.geojson": [
		93700,
		1,
		93700
	],
	"./assets/geojson/communes/00009-09117.geojson": [
		39241,
		1,
		39241
	],
	"./assets/geojson/communes/00009-09118.geojson": [
		87682,
		1,
		65301
	],
	"./assets/geojson/communes/00009-09119.geojson": [
		93623,
		1,
		93623
	],
	"./assets/geojson/communes/00009-09120.geojson": [
		19063,
		1,
		19063
	],
	"./assets/geojson/communes/00009-09121.geojson": [
		8546,
		1,
		8546
	],
	"./assets/geojson/communes/00009-09201.geojson": [
		77907,
		1,
		77907
	],
	"./assets/geojson/communes/00009-09202.geojson": [
		6268,
		1,
		6268
	],
	"./assets/geojson/communes/00009-09203.geojson": [
		41089,
		1,
		41089
	],
	"./assets/geojson/communes/00009-09204.geojson": [
		23650,
		1,
		23650
	],
	"./assets/geojson/communes/00009-09205.geojson": [
		35255,
		1,
		35255
	],
	"./assets/geojson/communes/00009-09206.geojson": [
		53776,
		1,
		53776
	],
	"./assets/geojson/communes/00009-09207.geojson": [
		17173,
		1,
		17173
	],
	"./assets/geojson/communes/00009-09208.geojson": [
		48326,
		1,
		48326
	],
	"./assets/geojson/communes/00009-09209.geojson": [
		87611,
		1,
		87611
	],
	"./assets/geojson/communes/00009-09210.geojson": [
		64429,
		1,
		64429
	],
	"./assets/geojson/communes/00009-09211.geojson": [
		62088,
		1,
		62088
	],
	"./assets/geojson/communes/00009.txt": [
		66553,
		1,
		66553
	],
	"./assets/geojson/communes/00010-10101.geojson": [
		52724,
		1,
		52724
	],
	"./assets/geojson/communes/00010-10102.geojson": [
		42987,
		1,
		42987
	],
	"./assets/geojson/communes/00010-10103.geojson": [
		91542,
		1,
		91542
	],
	"./assets/geojson/communes/00010-10104.geojson": [
		48301,
		1,
		48301
	],
	"./assets/geojson/communes/00010-10105.geojson": [
		89480,
		1,
		89480
	],
	"./assets/geojson/communes/00010-10106.geojson": [
		14255,
		1,
		14255
	],
	"./assets/geojson/communes/00010-10107.geojson": [
		75706,
		1,
		75706
	],
	"./assets/geojson/communes/00010-10108.geojson": [
		73841,
		1,
		73841
	],
	"./assets/geojson/communes/00010-10109.geojson": [
		75468,
		1,
		75468
	],
	"./assets/geojson/communes/00010-10201.geojson": [
		36403,
		1,
		36403
	],
	"./assets/geojson/communes/00010-10202.geojson": [
		98908,
		1,
		98908
	],
	"./assets/geojson/communes/00010-10203.geojson": [
		27329,
		1,
		27329
	],
	"./assets/geojson/communes/00010-10204.geojson": [
		13890,
		1,
		13890
	],
	"./assets/geojson/communes/00010-10205.geojson": [
		56772,
		1,
		34391
	],
	"./assets/geojson/communes/00010-10206.geojson": [
		10288,
		1,
		10288
	],
	"./assets/geojson/communes/00010-10207.geojson": [
		35893,
		1,
		35893
	],
	"./assets/geojson/communes/00010-10208.geojson": [
		25926,
		1,
		25926
	],
	"./assets/geojson/communes/00010-10209.geojson": [
		16475,
		1,
		16475
	],
	"./assets/geojson/communes/00010-10210.geojson": [
		94317,
		1,
		94317
	],
	"./assets/geojson/communes/00010-10301.geojson": [
		21638,
		1,
		21638
	],
	"./assets/geojson/communes/00010-10302.geojson": [
		37929,
		1,
		37929
	],
	"./assets/geojson/communes/00010-10303.geojson": [
		18020,
		1,
		18020
	],
	"./assets/geojson/communes/00010-10304.geojson": [
		54687,
		1,
		54687
	],
	"./assets/geojson/communes/00010-10305.geojson": [
		36125,
		1,
		58506
	],
	"./assets/geojson/communes/00010-10306.geojson": [
		48701,
		1,
		48701
	],
	"./assets/geojson/communes/00010-10307.geojson": [
		63096,
		1,
		63096
	],
	"./assets/geojson/communes/00010-10401.geojson": [
		29573,
		1,
		29573
	],
	"./assets/geojson/communes/00010-10402.geojson": [
		8530,
		1,
		8530
	],
	"./assets/geojson/communes/00010-10403.geojson": [
		94919,
		1,
		94919
	],
	"./assets/geojson/communes/00010-10404.geojson": [
		49324,
		1,
		49324
	],
	"./assets/geojson/communes/00010.geojson": [
		18310,
		1,
		18310
	],
	"./assets/geojson/communes/00011-11101.geojson": [
		74334,
		1,
		74334
	],
	"./assets/geojson/communes/00011-11102.geojson": [
		897,
		1,
		897
	],
	"./assets/geojson/communes/00011-11201.geojson": [
		45257,
		1,
		45257
	],
	"./assets/geojson/communes/00011-11202.geojson": [
		24358,
		1,
		24358
	],
	"./assets/geojson/communes/00011-11203.geojson": [
		43163,
		1,
		43163
	],
	"./assets/geojson/communes/00011-11301.geojson": [
		44332,
		1,
		44332
	],
	"./assets/geojson/communes/00011-11302.geojson": [
		64611,
		1,
		64611
	],
	"./assets/geojson/communes/00011-11303.geojson": [
		99566,
		1,
		99566
	],
	"./assets/geojson/communes/00011-11401.geojson": [
		69679,
		1,
		69679
	],
	"./assets/geojson/communes/00011-11402.geojson": [
		97896,
		1,
		97896
	],
	"./assets/geojson/communes/00011.geojson": [
		50011,
		1,
		50011
	],
	"./assets/geojson/communes/00012-12101.geojson": [
		87840,
		1,
		87840
	],
	"./assets/geojson/communes/00012-12102.geojson": [
		12775,
		1,
		12775
	],
	"./assets/geojson/communes/00012-12103.geojson": [
		1522,
		1,
		1522
	],
	"./assets/geojson/communes/00012-12104.geojson": [
		94257,
		1,
		94257
	],
	"./assets/geojson/communes/00012-12201.geojson": [
		19951,
		1,
		19951
	],
	"./assets/geojson/communes/00012-12301.geojson": [
		34274,
		1,
		34274
	],
	"./assets/geojson/communes/00012-12302.geojson": [
		96949,
		1,
		96949
	],
	"./assets/geojson/communes/00012-12303.geojson": [
		16208,
		1,
		16208
	],
	"./assets/geojson/communes/00012-12401.geojson": [
		95529,
		1,
		95529
	],
	"./assets/geojson/communes/00012-12402.geojson": [
		74630,
		1,
		74630
	],
	"./assets/geojson/communes/00012.geojson": [
		39076,
		1,
		39076
	],
	"./assets/geojson/communes/00013-13101.geojson": [
		61006,
		1,
		61006
	],
	"./assets/geojson/communes/00013-13102.geojson": [
		96625,
		1,
		96625
	],
	"./assets/geojson/communes/00013-13103.geojson": [
		77868,
		1,
		77868
	],
	"./assets/geojson/communes/00013-13104.geojson": [
		15143,
		1,
		15143
	],
	"./assets/geojson/communes/00013-13105.geojson": [
		3890,
		1,
		3890
	],
	"./assets/geojson/communes/00013-13106.geojson": [
		57893,
		1,
		57893
	],
	"./assets/geojson/communes/00013-13107.geojson": [
		90208,
		1,
		90208
	],
	"./assets/geojson/communes/00013-13108.geojson": [
		27563,
		1,
		27563
	],
	"./assets/geojson/communes/00013-13109.geojson": [
		17238,
		1,
		17238
	],
	"./assets/geojson/communes/00013-13110.geojson": [
		69308,
		1,
		69308
	],
	"./assets/geojson/communes/00013-13111.geojson": [
		81377,
		1,
		81377
	],
	"./assets/geojson/communes/00013-13112.geojson": [
		21854,
		1,
		21854
	],
	"./assets/geojson/communes/00013-13113.geojson": [
		90451,
		1,
		90451
	],
	"./assets/geojson/communes/00013-13114.geojson": [
		80688,
		1,
		80688
	],
	"./assets/geojson/communes/00013-13115.geojson": [
		6293,
		1,
		6293
	],
	"./assets/geojson/communes/00013-13116.geojson": [
		84290,
		1,
		84290
	],
	"./assets/geojson/communes/00013-13117.geojson": [
		4791,
		1,
		4791
	],
	"./assets/geojson/communes/00013-13118.geojson": [
		76356,
		1,
		76356
	],
	"./assets/geojson/communes/00013-13119.geojson": [
		96265,
		1,
		96265
	],
	"./assets/geojson/communes/00013-13120.geojson": [
		63589,
		1,
		63589
	],
	"./assets/geojson/communes/00013-13121.geojson": [
		81408,
		1,
		81408
	],
	"./assets/geojson/communes/00013-13122.geojson": [
		45319,
		1,
		45319
	],
	"./assets/geojson/communes/00013-13123.geojson": [
		75154,
		1,
		75154
	],
	"./assets/geojson/communes/00013-13124.geojson": [
		14545,
		1,
		14545
	],
	"./assets/geojson/communes/00013-13125.geojson": [
		99820,
		1,
		99820
	],
	"./assets/geojson/communes/00013-13126.geojson": [
		88707,
		1,
		88707
	],
	"./assets/geojson/communes/00013-13127.geojson": [
		16142,
		1,
		16142
	],
	"./assets/geojson/communes/00013-13128.geojson": [
		72653,
		1,
		72653
	],
	"./assets/geojson/communes/00013-13129.geojson": [
		13832,
		1,
		13832
	],
	"./assets/geojson/communes/00013-13130.geojson": [
		79574,
		1,
		79574
	],
	"./assets/geojson/communes/00013-13131.geojson": [
		80299,
		1,
		80299
	],
	"./assets/geojson/communes/00013-13132.geojson": [
		37012,
		1,
		37012
	],
	"./assets/geojson/communes/00013-13201.geojson": [
		24089,
		1,
		24089
	],
	"./assets/geojson/communes/00013-13202.geojson": [
		85942,
		1,
		85942
	],
	"./assets/geojson/communes/00013-13203.geojson": [
		86667,
		1,
		86667
	],
	"./assets/geojson/communes/00013-13301.geojson": [
		72956,
		1,
		72956
	],
	"./assets/geojson/communes/00013-13302.geojson": [
		94099,
		1,
		94099
	],
	"./assets/geojson/communes/00013-13303.geojson": [
		9150,
		1,
		9150
	],
	"./assets/geojson/communes/00013-13401.geojson": [
		8671,
		1,
		8671
	],
	"./assets/geojson/communes/00013-13402.geojson": [
		86232,
		1,
		86232
	],
	"./assets/geojson/communes/00013-13403.geojson": [
		29309,
		1,
		29309
	],
	"./assets/geojson/communes/00013-13404.geojson": [
		90566,
		1,
		90566
	],
	"./assets/geojson/communes/00013-13501.geojson": [
		91570,
		1,
		91570
	],
	"./assets/geojson/communes/00013-13502.geojson": [
		54597,
		1,
		54597
	],
	"./assets/geojson/communes/00013-13503.geojson": [
		89184,
		1,
		89184
	],
	"./assets/geojson/communes/00013-13504.geojson": [
		16259,
		1,
		16259
	],
	"./assets/geojson/communes/00013-13505.geojson": [
		51214,
		1,
		51214
	],
	"./assets/geojson/communes/00013-13601.geojson": [
		8013,
		1,
		8013
	],
	"./assets/geojson/communes/00013-13602.geojson": [
		17786,
		1,
		17786
	],
	"./assets/geojson/communes/00013-13603.geojson": [
		20399,
		1,
		20399
	],
	"./assets/geojson/communes/00013-13604.geojson": [
		27412,
		1,
		27412
	],
	"./assets/geojson/communes/00013-13605.geojson": [
		28537,
		1,
		28537
	],
	"./assets/geojson/communes/00013.geojson": [
		18793,
		1,
		18793
	],
	"./assets/geojson/communes/00014-14101.geojson": [
		55812,
		1,
		55812
	],
	"./assets/geojson/communes/00014-14102.geojson": [
		99259,
		1,
		99259
	],
	"./assets/geojson/communes/00014-14103.geojson": [
		80454,
		1,
		80454
	],
	"./assets/geojson/communes/00014-14104.geojson": [
		8605,
		1,
		8605
	],
	"./assets/geojson/communes/00014-14105.geojson": [
		49304,
		1,
		49304
	],
	"./assets/geojson/communes/00014-14106.geojson": [
		78079,
		1,
		78079
	],
	"./assets/geojson/communes/00014-14107.geojson": [
		94026,
		1,
		94026
	],
	"./assets/geojson/communes/00014-14108.geojson": [
		65121,
		1,
		65121
	],
	"./assets/geojson/communes/00014-14201.geojson": [
		49251,
		1,
		49251
	],
	"./assets/geojson/communes/00014-14202.geojson": [
		49292,
		1,
		49292
	],
	"./assets/geojson/communes/00014-14203.geojson": [
		49649,
		1,
		49649
	],
	"./assets/geojson/communes/00014-14204.geojson": [
		8498,
		1,
		8498
	],
	"./assets/geojson/communes/00014.geojson": [
		47082,
		1,
		47082
	],
	"./assets/geojson/communes/00015-15101.geojson": [
		8334,
		1,
		8334
	],
	"./assets/geojson/communes/00015-15102.geojson": [
		43953,
		1,
		43953
	],
	"./assets/geojson/communes/00015-15201.geojson": [
		71417,
		1,
		71417
	],
	"./assets/geojson/communes/00015-15202.geojson": [
		33270,
		1,
		33270
	],
	"./assets/geojson/communes/00015.geojson": [
		12383,
		1,
		12383
	],
	"./assets/geojson/communes/00016-16101.geojson": [
		97208,
		1,
		97208
	],
	"./assets/geojson/communes/00016-16102.geojson": [
		25983,
		1,
		25983
	],
	"./assets/geojson/communes/00016-16103.geojson": [
		41930,
		1,
		41930
	],
	"./assets/geojson/communes/00016-16104.geojson": [
		49257,
		1,
		49257
	],
	"./assets/geojson/communes/00016-16105.geojson": [
		3716,
		1,
		3716
	],
	"./assets/geojson/communes/00016-16106.geojson": [
		47163,
		1,
		47163
	],
	"./assets/geojson/communes/00016-16107.geojson": [
		28358,
		1,
		28358
	],
	"./assets/geojson/communes/00016-16108.geojson": [
		76725,
		1,
		76725
	],
	"./assets/geojson/communes/00016-16109.geojson": [
		95984,
		1,
		95984
	],
	"./assets/geojson/communes/00016-16201.geojson": [
		11207,
		1,
		11207
	],
	"./assets/geojson/communes/00016-16202.geojson": [
		55520,
		1,
		55520
	],
	"./assets/geojson/communes/00016-16203.geojson": [
		20933,
		1,
		20933
	],
	"./assets/geojson/communes/00016-16204.geojson": [
		17550,
		1,
		17550
	],
	"./assets/geojson/communes/00016-16205.geojson": [
		98947,
		1,
		98947
	],
	"./assets/geojson/communes/00016-16206.geojson": [
		62316,
		1,
		62316
	],
	"./assets/geojson/communes/00016-16207.geojson": [
		90833,
		1,
		90833
	],
	"./assets/geojson/communes/00016-16301.geojson": [
		12122,
		1,
		12122
	],
	"./assets/geojson/communes/00016-16302.geojson": [
		85709,
		1,
		85709
	],
	"./assets/geojson/communes/00016-16303.geojson": [
		83368,
		1,
		83368
	],
	"./assets/geojson/communes/00016-16304.geojson": [
		53003,
		1,
		53003
	],
	"./assets/geojson/communes/00016-16305.geojson": [
		52278,
		1,
		52278
	],
	"./assets/geojson/communes/00016.geojson": [
		42488,
		1,
		42488
	],
	"./assets/geojson/communes/base.geojson": [
		75414,
		1,
		75414
	],
	"./assets/geojson/communes/geo.txt": [
		41195,
		1,
		41195
	],
	"./assets/icons/alert-46.svg": [
		41618,
		1,
		41618
	],
	"./assets/icons/alert.ico": [
		6398,
		1,
		6398
	],
	"./assets/icons/arrow-left-icon.svg": [
		62498,
		1,
		62498
	],
	"./assets/icons/close.svg": [
		35837,
		1,
		35837
	],
	"./assets/icons/edit-icon.svg": [
		41331,
		1,
		41331
	],
	"./assets/icons/entel-status/awaiting_delivery-icon.svg": [
		64166,
		1,
		64166
	],
	"./assets/icons/entel-status/awaiting_store_confirmation-icon.svg": [
		6609,
		1,
		6609
	],
	"./assets/icons/entel-status/canceled-icon.svg": [
		62128,
		1,
		62128
	],
	"./assets/icons/entel-status/closed-icon.svg": [
		94419,
		1,
		94419
	],
	"./assets/icons/entel-status/delivered-icon.svg": [
		86721,
		1,
		86721
	],
	"./assets/icons/entel-status/in_return-icon.svg": [
		96383,
		1,
		96383
	],
	"./assets/icons/entel-status/in_return_courier-icon.svg": [
		59967,
		1,
		59967
	],
	"./assets/icons/entel-status/in_source_preparation-icon.svg": [
		86054,
		1,
		86054
	],
	"./assets/icons/entel-status/in_transit-icon.svg": [
		20136,
		1,
		20136
	],
	"./assets/icons/entel-status/pending_package-icon.svg": [
		80729,
		1,
		80729
	],
	"./assets/icons/entel-status/pickup-icon.svg": [
		99539,
		1,
		99539
	],
	"./assets/icons/entel-status/ready_for_pickup-icon.svg": [
		11255,
		1,
		11255
	],
	"./assets/icons/entel-status/rescheduled-icon.svg": [
		54893,
		1,
		54893
	],
	"./assets/icons/entel-status/return_in_review-icon.svg": [
		45046,
		1,
		45046
	],
	"./assets/icons/entel-status/returned-icon.svg": [
		17748,
		1,
		17748
	],
	"./assets/icons/entel/close.svg": [
		16596,
		1,
		16596
	],
	"./assets/icons/entel/edit-icon.svg": [
		69542,
		1,
		69542
	],
	"./assets/icons/entel/folder_upload_icon.svg": [
		13936,
		1,
		13936
	],
	"./assets/icons/entel/logout-icon.svg": [
		13468,
		1,
		13468
	],
	"./assets/icons/entel/menu/canceled-icon.svg": [
		98021,
		1,
		98021
	],
	"./assets/icons/entel/menu/closed-icon.svg": [
		42218,
		1,
		42218
	],
	"./assets/icons/entel/menu/confirm-icon.svg": [
		24746,
		1,
		24746
	],
	"./assets/icons/entel/menu/delivered-icon.svg": [
		17570,
		1,
		17570
	],
	"./assets/icons/entel/menu/delivery-icon.svg": [
		4114,
		1,
		4114
	],
	"./assets/icons/entel/menu/package-icon.svg": [
		29050,
		1,
		29050
	],
	"./assets/icons/entel/menu/pickup-icon.svg": [
		12822,
		1,
		12822
	],
	"./assets/icons/entel/menu/shipped-icon.svg": [
		46857,
		1,
		46857
	],
	"./assets/icons/entel/trash-icon.svg": [
		5152,
		1,
		5152
	],
	"./assets/icons/entel/user_icon_alt.svg": [
		70191,
		1,
		70191
	],
	"./assets/icons/folder_upload_icon.svg": [
		20939,
		1,
		20939
	],
	"./assets/icons/hamburger.svg": [
		61180,
		1,
		61180
	],
	"./assets/icons/info_icon.svg": [
		29581,
		1,
		29581
	],
	"./assets/icons/logout-icon.svg": [
		81129,
		1,
		81129
	],
	"./assets/icons/loupe-icon.svg": [
		30114,
		1,
		30114
	],
	"./assets/icons/menu-admin-actions-icon.svg": [
		2240,
		1,
		2240
	],
	"./assets/icons/menu-buy-icon.svg": [
		48825,
		1,
		48825
	],
	"./assets/icons/menu-calendar-icon.svg": [
		75597,
		1,
		75597
	],
	"./assets/icons/menu-home-icon.svg": [
		23384,
		1,
		23384
	],
	"./assets/icons/menu-stats-icon.svg": [
		75362,
		1,
		75362
	],
	"./assets/icons/menu/canceled-icon.svg": [
		34710,
		1,
		34710
	],
	"./assets/icons/menu/closed-icon.svg": [
		94241,
		1,
		94241
	],
	"./assets/icons/menu/confirm-icon.svg": [
		3035,
		1,
		3035
	],
	"./assets/icons/menu/delivered-icon.svg": [
		15623,
		1,
		15623
	],
	"./assets/icons/menu/delivery-icon.svg": [
		1701,
		1,
		1701
	],
	"./assets/icons/menu/package-icon.svg": [
		79335,
		1,
		79335
	],
	"./assets/icons/menu/pickup-icon.svg": [
		81685,
		1,
		81685
	],
	"./assets/icons/menu/shipped-icon.svg": [
		26984,
		1,
		26984
	],
	"./assets/icons/password_icon.svg": [
		27604,
		1,
		27604
	],
	"./assets/icons/plus-icon.svg": [
		8879,
		1,
		8879
	],
	"./assets/icons/portabilidad.svg": [
		9852,
		1,
		9852
	],
	"./assets/icons/red-circle-svgrepo-com.svg": [
		94732,
		1,
		94732
	],
	"./assets/icons/ship_ico.svg": [
		43035,
		1,
		43035
	],
	"./assets/icons/shiperto-status/awaiting_delivery-icon.svg": [
		41196,
		1
	],
	"./assets/icons/shiperto-status/awaiting_store_confirmation-icon.svg": [
		87219,
		1
	],
	"./assets/icons/shiperto-status/canceled-icon.svg": [
		39982,
		1
	],
	"./assets/icons/shiperto-status/closed-icon.svg": [
		23993,
		1
	],
	"./assets/icons/shiperto-status/delivered-icon.svg": [
		91855,
		1
	],
	"./assets/icons/shiperto-status/in_return-icon.svg": [
		76665,
		1
	],
	"./assets/icons/shiperto-status/in_return_courier-icon.svg": [
		75085,
		1
	],
	"./assets/icons/shiperto-status/in_source_preparation-icon.svg": [
		79480,
		1
	],
	"./assets/icons/shiperto-status/in_transit-icon.svg": [
		87710,
		1
	],
	"./assets/icons/shiperto-status/pending_package-icon.svg": [
		64555,
		1
	],
	"./assets/icons/shiperto-status/pickup-icon.svg": [
		96365,
		1
	],
	"./assets/icons/shiperto-status/ready_for_pickup-icon.svg": [
		721,
		1
	],
	"./assets/icons/shiperto-status/rescheduled-icon.svg": [
		89783,
		1
	],
	"./assets/icons/shiperto-status/return_in_review-icon.svg": [
		53308,
		1
	],
	"./assets/icons/shiperto-status/returned-icon.svg": [
		4826,
		1
	],
	"./assets/icons/store.svg": [
		55414,
		1,
		55414
	],
	"./assets/icons/trash-icon.svg": [
		44927,
		1,
		44927
	],
	"./assets/icons/user_icon.svg": [
		66110,
		1,
		66110
	],
	"./assets/icons/user_icon_alt.svg": [
		32582,
		1,
		32582
	],
	"./assets/images/background-image-ship.svg": [
		33666,
		1,
		33666
	],
	"./assets/images/entel/product-image-default.svg": [
		67173,
		1,
		67173
	],
	"./assets/images/logo-omnix3.png": [
		13757,
		1
	],
	"./assets/images/logo_entel.svg": [
		72195,
		1,
		72195
	],
	"./assets/images/logo_omnix2.png": [
		52194,
		1,
		52194
	],
	"./assets/images/logo_shiperto.svg": [
		10677,
		1,
		10677
	],
	"./assets/images/shade-backg-ship.svg": [
		85144,
		1,
		85144
	],
	"./assets/images/shiperto/product-image-default.svg": [
		23027,
		1,
		23027
	],
	"./classes": [
		84757,
		9
	],
	"./classes/": [
		84757,
		9
	],
	"./classes/AxiosClient": [
		3376,
		9
	],
	"./classes/AxiosClient.ts": [
		3376,
		9
	],
	"./classes/Env": [
		24030,
		9
	],
	"./classes/Env.ts": [
		24030,
		9
	],
	"./classes/JsonEngine": [
		2881,
		9
	],
	"./classes/JsonEngine.ts": [
		2881,
		9
	],
	"./classes/Logger": [
		15575,
		9
	],
	"./classes/Logger.ts": [
		15575,
		9
	],
	"./classes/MultiClient": [
		47279,
		9
	],
	"./classes/MultiClient.ts": [
		47279,
		9
	],
	"./classes/index": [
		84757,
		9
	],
	"./classes/index.ts": [
		84757,
		9
	],
	"./components/Commons/AutoComplete/InputAutoComplete": [
		82377,
		9,
		82377
	],
	"./components/Commons/AutoComplete/InputAutoComplete.sryled": [
		48688,
		9,
		48688
	],
	"./components/Commons/AutoComplete/InputAutoComplete.sryled.ts": [
		48688,
		9,
		48688
	],
	"./components/Commons/AutoComplete/InputAutoComplete.tsx": [
		82377,
		9,
		82377
	],
	"./components/Commons/BackBotton/BackBotton": [
		77011,
		9
	],
	"./components/Commons/BackBotton/BackBotton.styled": [
		29408,
		9
	],
	"./components/Commons/BackBotton/BackBotton.styled.ts": [
		29408,
		9
	],
	"./components/Commons/BackBotton/BackBotton.tsx": [
		77011,
		9
	],
	"./components/Commons/BarCode": [
		7967,
		9
	],
	"./components/Commons/BarCode.tsx": [
		7967,
		9
	],
	"./components/Commons/BrandClient/LogoClient": [
		37169,
		9
	],
	"./components/Commons/BrandClient/LogoClient.tsx": [
		37169,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar": [
		80726,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar.styled": [
		68574,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar.styled.ts": [
		68574,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar.tsx": [
		80726,
		9
	],
	"./components/Commons/CheckBox": [
		10083,
		9
	],
	"./components/Commons/CheckBox.tsx": [
		10083,
		9
	],
	"./components/Commons/ColorPicker": [
		85484,
		9
	],
	"./components/Commons/ColorPicker/": [
		85484,
		9
	],
	"./components/Commons/ColorPicker/ColorPicker.module.css": [
		93627,
		9
	],
	"./components/Commons/ColorPicker/index": [
		85484,
		9
	],
	"./components/Commons/ColorPicker/index.tsx": [
		85484,
		9
	],
	"./components/Commons/Error/ErrorHandler": [
		80731,
		9
	],
	"./components/Commons/Error/ErrorHandler.styled": [
		43560,
		9
	],
	"./components/Commons/Error/ErrorHandler.styled.ts": [
		43560,
		9
	],
	"./components/Commons/Error/ErrorHandler.tsx": [
		80731,
		9
	],
	"./components/Commons/FileUpload/FileUpalder": [
		82392,
		9
	],
	"./components/Commons/FileUpload/FileUpalder.tsx": [
		82392,
		9
	],
	"./components/Commons/FileUpload/Uploader.styled": [
		81439,
		9
	],
	"./components/Commons/FileUpload/Uploader.styled.ts": [
		81439,
		9
	],
	"./components/Commons/Helmet/Helmet": [
		6813,
		9
	],
	"./components/Commons/Helmet/Helmet.tsx": [
		6813,
		9
	],
	"./components/Commons/HomeBotton/HomeBotton": [
		34907,
		9
	],
	"./components/Commons/HomeBotton/HomeBotton.tsx": [
		34907,
		9
	],
	"./components/Commons/HomeBotton/HomeButton.styled": [
		54894,
		9
	],
	"./components/Commons/HomeBotton/HomeButton.styled.ts": [
		54894,
		9
	],
	"./components/Commons/Image/Image": [
		80615,
		9
	],
	"./components/Commons/Image/Image.styled": [
		81052,
		9
	],
	"./components/Commons/Image/Image.styled.ts": [
		81052,
		9
	],
	"./components/Commons/Image/Image.tsx": [
		80615,
		9
	],
	"./components/Commons/Input": [
		8238,
		9
	],
	"./components/Commons/Input.tsx": [
		8238,
		9
	],
	"./components/Commons/Loading/Loading": [
		93223,
		9
	],
	"./components/Commons/Loading/Loading.tsx": [
		93223,
		9
	],
	"./components/Commons/Modal/Modal": [
		56183,
		9
	],
	"./components/Commons/Modal/Modal.styled": [
		85740,
		9
	],
	"./components/Commons/Modal/Modal.styled.ts": [
		85740,
		9
	],
	"./components/Commons/Modal/Modal.tsx": [
		56183,
		9
	],
	"./components/Commons/MultiSelect/MultiSelect": [
		50667,
		9,
		50667
	],
	"./components/Commons/MultiSelect/MultiSelect.module.css": [
		98751,
		9,
		98751
	],
	"./components/Commons/MultiSelect/MultiSelect.tsx": [
		50667,
		9,
		50667
	],
	"./components/Commons/Notifications/Notification": [
		33162,
		9,
		33162
	],
	"./components/Commons/Notifications/Notification.tsx": [
		33162,
		9,
		33162
	],
	"./components/Commons/Notifications/NotificationList": [
		96994,
		9
	],
	"./components/Commons/Notifications/NotificationList.tsx": [
		96994,
		9
	],
	"./components/Commons/Pagination/Paginate": [
		22006,
		9
	],
	"./components/Commons/Pagination/Paginate.tsx": [
		22006,
		9
	],
	"./components/Commons/Pagination/Pagination.styled": [
		58494,
		9
	],
	"./components/Commons/Pagination/Pagination.styled.ts": [
		58494,
		9
	],
	"./components/Commons/PrivateRouteComponent": [
		63567,
		9
	],
	"./components/Commons/PrivateRouteComponent.tsx": [
		63567,
		9
	],
	"./components/Commons/PublicRouteComponent": [
		65139,
		9
	],
	"./components/Commons/PublicRouteComponent.tsx": [
		65139,
		9
	],
	"./components/Commons/RadioButton": [
		5547,
		9
	],
	"./components/Commons/RadioButton.tsx": [
		5547,
		9
	],
	"./components/Commons/SelectBox/SelectBox": [
		68107,
		9
	],
	"./components/Commons/SelectBox/SelectBox.styled": [
		10040,
		9
	],
	"./components/Commons/SelectBox/SelectBox.styled.ts": [
		10040,
		9
	],
	"./components/Commons/SelectBox/SelectBox.tsx": [
		68107,
		9
	],
	"./components/Commons/Skeleton/SkeletonGrid": [
		23903,
		9
	],
	"./components/Commons/Skeleton/SkeletonGrid.tsx": [
		23903,
		9
	],
	"./components/Commons/Skeleton/SkeletonGroupOrden": [
		28796,
		9
	],
	"./components/Commons/Skeleton/SkeletonGroupOrden.tsx": [
		28796,
		9
	],
	"./components/Commons/Skeleton/SkeletonShippinGroupDetail": [
		9276,
		9
	],
	"./components/Commons/Skeleton/SkeletonShippinGroupDetail.tsx": [
		9276,
		9
	],
	"./components/Commons/Skeleton/SkeletonThemeContainer": [
		35823,
		9
	],
	"./components/Commons/Skeleton/SkeletonThemeContainer.tsx": [
		35823,
		9
	],
	"./components/Commons/TimeSelector/TimeSelector": [
		40545,
		9
	],
	"./components/Commons/TimeSelector/TimeSelector.style": [
		42328,
		9
	],
	"./components/Commons/TimeSelector/TimeSelector.style.ts": [
		42328,
		9
	],
	"./components/Commons/TimeSelector/TimeSelector.tsx": [
		40545,
		9
	],
	"./components/Commons/WindowModal/WindowModal": [
		77399,
		9
	],
	"./components/Commons/WindowModal/WindowModal.styled": [
		62860,
		9
	],
	"./components/Commons/WindowModal/WindowModal.styled.ts": [
		62860,
		9
	],
	"./components/Commons/WindowModal/WindowModal.tsx": [
		77399,
		9
	],
	"./components/Core/DocumentsFiles/FileCard": [
		38295,
		9,
		38295
	],
	"./components/Core/DocumentsFiles/FileCard.styled": [
		77356,
		9,
		77356
	],
	"./components/Core/DocumentsFiles/FileCard.styled.ts": [
		77356,
		9,
		77356
	],
	"./components/Core/DocumentsFiles/FileCard.tsx": [
		38295,
		9,
		38295
	],
	"./components/Core/DocumentsFiles/FilesList": [
		32444,
		9,
		87682
	],
	"./components/Core/DocumentsFiles/FilesList.tsx": [
		32444,
		9,
		87682
	],
	"./components/Core/Multiclient": [
		7091,
		9
	],
	"./components/Core/Multiclient.tsx": [
		7091,
		9
	],
	"./components/Core/Order/CardOrder/CardOrdeItem": [
		1450,
		9
	],
	"./components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		1450,
		9
	],
	"./components/Core/Order/CardOrder/CardOrderItem.styled": [
		38059,
		9
	],
	"./components/Core/Order/CardOrder/CardOrderItem.styled.ts": [
		38059,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar": [
		45732,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar.tsx": [
		45732,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar": [
		2408,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.styled": [
		51903,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.styled.ts": [
		51903,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.tsx": [
		2408,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate": [
		72939,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate.styled": [
		5144,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate.styled.ts": [
		5144,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate.tsx": [
		72939,
		9
	],
	"./components/Core/Order/OrderList": [
		11528,
		9
	],
	"./components/Core/Order/OrderList.styled": [
		6623,
		9
	],
	"./components/Core/Order/OrderList.styled.ts": [
		6623,
		9
	],
	"./components/Core/Order/OrderList.tsx": [
		11528,
		9
	],
	"./components/Core/Order/Sort/SortOrder": [
		91779,
		9
	],
	"./components/Core/Order/Sort/SortOrder.styled": [
		99248,
		9
	],
	"./components/Core/Order/Sort/SortOrder.styled.ts": [
		99248,
		9
	],
	"./components/Core/Order/Sort/SortOrder.tsx": [
		91779,
		9
	],
	"./components/Core/Order/hooks/UseChekedOrderList": [
		75248,
		9
	],
	"./components/Core/Order/hooks/UseChekedOrderList.ts": [
		75248,
		9
	],
	"./components/Core/Order/hooks/UseConditionalsGroupOrder": [
		35912,
		9
	],
	"./components/Core/Order/hooks/UseConditionalsGroupOrder.ts": [
		35912,
		9
	],
	"./components/Core/ProductBase/ProductDetail": [
		73300,
		9
	],
	"./components/Core/ProductBase/ProductDetail.tsx": [
		73300,
		9
	],
	"./components/Core/ProductTransition/ManualTransition": [
		59005,
		9,
		59005
	],
	"./components/Core/ProductTransition/ManualTransition.tsx": [
		59005,
		9,
		59005
	],
	"./components/Core/ProductTransition/ScannerlTransition": [
		1189,
		9,
		1189
	],
	"./components/Core/ProductTransition/ScannerlTransition.tsx": [
		1189,
		9,
		1189
	],
	"./components/Core/ScannerSimple/ScannerSimple": [
		6376,
		9,
		11749,
		6376
	],
	"./components/Core/ScannerSimple/ScannerSimple.tsx": [
		6376,
		9,
		11749,
		6376
	],
	"./components/OrderDetail/DeliveryProductOrder/DeliveryAction": [
		2295,
		9
	],
	"./components/OrderDetail/DeliveryProductOrder/DeliveryAction.tsx": [
		2295,
		9
	],
	"./components/OrderDetail/ElockerQR/InfoElocker": [
		27739,
		9,
		27739
	],
	"./components/OrderDetail/ElockerQR/InfoElocker.styled": [
		21864,
		9,
		21864
	],
	"./components/OrderDetail/ElockerQR/InfoElocker.styled.ts": [
		21864,
		9,
		21864
	],
	"./components/OrderDetail/ElockerQR/InfoElocker.tsx": [
		27739,
		9,
		27739
	],
	"./components/OrderDetail/ElockerQR/QRCodeElocker": [
		2813,
		9,
		2813
	],
	"./components/OrderDetail/ElockerQR/QRCodeElocker.tsx": [
		2813,
		9,
		2813
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail": [
		70000,
		9
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail.styled": [
		20647,
		9
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail.styled.ts": [
		20647,
		9
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail.tsx": [
		70000,
		9
	],
	"./components/OrderDetail/HistoryStatus/StatusShippingGroup": [
		25817,
		9,
		25817
	],
	"./components/OrderDetail/HistoryStatus/StatusShippingGroup.tsx": [
		25817,
		9,
		25817
	],
	"./components/OrderDetail/PackageProductOrder/PackageAction": [
		90991,
		9
	],
	"./components/OrderDetail/PackageProductOrder/PackageAction.tsx": [
		90991,
		9
	],
	"./components/OrderDetail/PickupProductOrder/PickupAction": [
		80551,
		9
	],
	"./components/OrderDetail/PickupProductOrder/PickupAction.tsx": [
		80551,
		9
	],
	"./components/OrderDetail/ProcessProducts/PickingAction": [
		47610,
		9
	],
	"./components/OrderDetail/ProcessProducts/PickingAction.tsx": [
		47610,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard": [
		58754,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard.styled": [
		2953,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard.styled.ts": [
		2953,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard.tsx": [
		58754,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductsList": [
		9850,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductsList.tsx": [
		9850,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductCount": [
		91877,
		9,
		91877
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductCount.tsx": [
		91877,
		9,
		91877
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductInformation": [
		25366,
		9,
		25366
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductInformation.tsx": [
		25366,
		9,
		25366
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOderDetail": [
		82145,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOderDetail.tsx": [
		82145,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOrderDetail.styled": [
		56616,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOrderDetail.styled.ts": [
		56616,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts": [
		73413,
		9,
		11749,
		73413
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts.styled": [
		20450,
		9,
		20450
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts.styled.ts": [
		20450,
		9,
		20450
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts.tsx": [
		73413,
		9,
		11749,
		73413
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput": [
		54356,
		9,
		54356
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput.styled": [
		62931,
		9,
		62931
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput.styled.ts": [
		62931,
		9,
		62931
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput.tsx": [
		54356,
		9,
		54356
	],
	"./components/OrderDetail/SendCode/SendCode": [
		86486,
		9
	],
	"./components/OrderDetail/SendCode/SendCode.styled": [
		19445,
		9
	],
	"./components/OrderDetail/SendCode/SendCode.styled.ts": [
		19445,
		9
	],
	"./components/OrderDetail/SendCode/SendCode.tsx": [
		86486,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard": [
		41843,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled": [
		88800,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled.ts": [
		88800,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.tsx": [
		41843,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductsList": [
		26710,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductsList.tsx": [
		26710,
		9
	],
	"./components/OrderDetail/TagPrint/TagInfoCustomer": [
		68979,
		9
	],
	"./components/OrderDetail/TagPrint/TagInfoCustomer.tsx": [
		68979,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent": [
		13372,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent.styled": [
		41316,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent.styled.ts": [
		41316,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent.tsx": [
		13372,
		9
	],
	"./components/OrderDetail/TagPrint/render": [
		52770,
		9
	],
	"./components/OrderDetail/TagPrint/render/": [
		52770,
		9
	],
	"./components/OrderDetail/TagPrint/render/Field": [
		92078,
		9
	],
	"./components/OrderDetail/TagPrint/render/Field.tsx": [
		92078,
		9
	],
	"./components/OrderDetail/TagPrint/render/Fields": [
		79043,
		9
	],
	"./components/OrderDetail/TagPrint/render/Fields.tsx": [
		79043,
		9
	],
	"./components/OrderDetail/TagPrint/render/dataFields": [
		72339,
		9
	],
	"./components/OrderDetail/TagPrint/render/dataFields.tsx": [
		72339,
		9
	],
	"./components/OrderDetail/TagPrint/render/index": [
		52770,
		9
	],
	"./components/OrderDetail/TagPrint/render/index.tsx": [
		52770,
		9
	],
	"./components/OrderDetail/TransitProductOrder/TransitAction": [
		6815,
		9
	],
	"./components/OrderDetail/TransitProductOrder/TransitAction.tsx": [
		6815,
		9
	],
	"./components/SearchForm/SearchForm": [
		89250,
		9
	],
	"./components/SearchForm/SearchForm.styled": [
		86953,
		9
	],
	"./components/SearchForm/SearchForm.styled.ts": [
		86953,
		9
	],
	"./components/SearchForm/SearchForm.tsx": [
		89250,
		9
	],
	"./components/Summary/Summary.styled": [
		36787,
		9
	],
	"./components/Summary/Summary.styled.ts": [
		36787,
		9
	],
	"./components/Summary/SummaryOption/CardOption": [
		28565,
		9
	],
	"./components/Summary/SummaryOption/CardOption.styled": [
		17586,
		9
	],
	"./components/Summary/SummaryOption/CardOption.styled.ts": [
		17586,
		9
	],
	"./components/Summary/SummaryOption/CardOption.tsx": [
		28565,
		9
	],
	"./components/Summary/SummaryOptions": [
		71012,
		9
	],
	"./components/Summary/SummaryOptions.tsx": [
		71012,
		9
	],
	"./components/Theme/Header/Header": [
		49526,
		9
	],
	"./components/Theme/Header/Header.styled": [
		23861,
		9
	],
	"./components/Theme/Header/Header.styled.ts": [
		23861,
		9
	],
	"./components/Theme/Header/Header.tsx": [
		49526,
		9
	],
	"./components/Theme/Layout/Main/MainLayout": [
		29215,
		9
	],
	"./components/Theme/Layout/Main/MainLayout.styled": [
		22868,
		9
	],
	"./components/Theme/Layout/Main/MainLayout.styled.ts": [
		22868,
		9
	],
	"./components/Theme/Layout/Main/MainLayout.tsx": [
		29215,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu": [
		1616,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu.styled": [
		62247,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu.styled.ts": [
		62247,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu.tsx": [
		1616,
		9
	],
	"./components/Theme/Sidebar/SideBar": [
		98170,
		9
	],
	"./components/Theme/Sidebar/SideBar.styled": [
		46273,
		9
	],
	"./components/Theme/Sidebar/SideBar.styled.ts": [
		46273,
		9
	],
	"./components/Theme/Sidebar/SideBar.tsx": [
		98170,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection": [
		46754,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection.styled": [
		69865,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection.styled.ts": [
		69865,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection.tsx": [
		46754,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage": [
		35586,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage.styled": [
		64905,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage.styled.ts": [
		64905,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage.tsx": [
		35586,
		9
	],
	"./components/Transfer/ProcessProductCard/ProcessProductCard": [
		5490,
		9
	],
	"./components/Transfer/ProcessProductCard/ProcessProductCard.tsx": [
		5490,
		9
	],
	"./components/Transfer/ProcessProductsList": [
		98282,
		9
	],
	"./components/Transfer/ProcessProductsList.tsx": [
		98282,
		9
	],
	"./components/User/Login/LoginForm": [
		89438,
		9,
		89438
	],
	"./components/User/Login/LoginForm.styled": [
		37309,
		9,
		37309
	],
	"./components/User/Login/LoginForm.styled.ts": [
		37309,
		9,
		37309
	],
	"./components/User/Login/LoginForm.tsx": [
		89438,
		9,
		89438
	],
	"./components/User/Login/Logo": [
		22534,
		9,
		22534
	],
	"./components/User/Login/Logo.tsx": [
		22534,
		9,
		22534
	],
	"./components/User/Profile/UserInfo/UserInfoProfile": [
		17311,
		9
	],
	"./components/User/Profile/UserInfo/UserInfoProfile.styled": [
		19220,
		9
	],
	"./components/User/Profile/UserInfo/UserInfoProfile.styled.ts": [
		19220,
		9
	],
	"./components/User/Profile/UserInfo/UserInfoProfile.tsx": [
		17311,
		9
	],
	"./components/User/Profile/UserProfileForm": [
		44669,
		9
	],
	"./components/User/Profile/UserProfileForm.styled": [
		9594,
		9
	],
	"./components/User/Profile/UserProfileForm.styled.ts": [
		9594,
		9
	],
	"./components/User/Profile/UserProfileForm.tsx": [
		44669,
		9
	],
	"./config/ShemaForms": [
		24144,
		9
	],
	"./config/ShemaForms.ts": [
		24144,
		9
	],
	"./config/axiosClient": [
		49584,
		9
	],
	"./config/axiosClient.ts": [
		49584,
		9
	],
	"./config/config": [
		57999,
		9
	],
	"./config/config.ts": [
		57999,
		9
	],
	"./config/configEnv": [
		14464,
		9
	],
	"./config/configEnv.ts": [
		14464,
		9
	],
	"./containers/App/AppContainer": [
		25767,
		9
	],
	"./containers/App/AppContainer.tsx": [
		25767,
		9
	],
	"./containers/DashBoard/DashboardContainer": [
		36367,
		9
	],
	"./containers/DashBoard/DashboardContainer.tsx": [
		36367,
		9
	],
	"./context/actionsTypes": [
		50399,
		9
	],
	"./context/actionsTypes/": [
		50399,
		9
	],
	"./context/actionsTypes/AuthTypes": [
		11312,
		9,
		11312
	],
	"./context/actionsTypes/AuthTypes.ts": [
		11312,
		9,
		11312
	],
	"./context/actionsTypes/NotificationActionsType": [
		12553,
		9,
		12553
	],
	"./context/actionsTypes/NotificationActionsType.ts": [
		12553,
		9,
		12553
	],
	"./context/actionsTypes/OrderTypes": [
		57906,
		9
	],
	"./context/actionsTypes/OrderTypes.ts": [
		57906,
		9
	],
	"./context/actionsTypes/index": [
		50399,
		9
	],
	"./context/actionsTypes/index.ts": [
		50399,
		9
	],
	"./context/context": [
		44890,
		9
	],
	"./context/context/": [
		44890,
		9
	],
	"./context/context/AuthContext": [
		23197,
		9
	],
	"./context/context/AuthContext.tsx": [
		23197,
		9
	],
	"./context/context/GlobalContext": [
		6480,
		9
	],
	"./context/context/GlobalContext.tsx": [
		6480,
		9
	],
	"./context/context/OrderContext": [
		48965,
		9
	],
	"./context/context/OrderContext.tsx": [
		48965,
		9
	],
	"./context/context/index": [
		44890,
		9
	],
	"./context/context/index.ts": [
		44890,
		9
	],
	"./context/inits": [
		82134,
		9,
		82134
	],
	"./context/inits/": [
		82134,
		9,
		82134
	],
	"./context/inits/AuthReducerInit": [
		56762,
		9
	],
	"./context/inits/AuthReducerInit.ts": [
		56762,
		9
	],
	"./context/inits/OrderReducerInit": [
		2242,
		9
	],
	"./context/inits/OrderReducerInit.ts": [
		2242,
		9
	],
	"./context/inits/index": [
		82134,
		9,
		82134
	],
	"./context/inits/index.ts": [
		82134,
		9,
		82134
	],
	"./context/providers": [
		58575,
		9
	],
	"./context/providers/": [
		58575,
		9
	],
	"./context/providers/AuthProvider": [
		59692,
		9
	],
	"./context/providers/AuthProvider.tsx": [
		59692,
		9
	],
	"./context/providers/GlobalProvider": [
		44967,
		9
	],
	"./context/providers/GlobalProvider.tsx": [
		44967,
		9
	],
	"./context/providers/OrderProvider": [
		71538,
		9
	],
	"./context/providers/OrderProvider.tsx": [
		71538,
		9
	],
	"./context/providers/index": [
		58575,
		9
	],
	"./context/providers/index.ts": [
		58575,
		9
	],
	"./context/reducers": [
		90306,
		9
	],
	"./context/reducers/": [
		90306,
		9
	],
	"./context/reducers/AuthReducer": [
		64704,
		9
	],
	"./context/reducers/AuthReducer.ts": [
		64704,
		9
	],
	"./context/reducers/NotificationReducer": [
		9379,
		9
	],
	"./context/reducers/NotificationReducer.ts": [
		9379,
		9
	],
	"./context/reducers/OrderReducer": [
		85448,
		9
	],
	"./context/reducers/OrderReducer.ts": [
		85448,
		9
	],
	"./context/reducers/index": [
		90306,
		9
	],
	"./context/reducers/index.ts": [
		90306,
		9
	],
	"./context/types/GlobalStateTypes": [
		37251,
		9,
		37251
	],
	"./context/types/GlobalStateTypes.ts": [
		37251,
		9,
		37251
	],
	"./enums/CommonEnum": [
		20971,
		9
	],
	"./enums/CommonEnum.ts": [
		20971,
		9
	],
	"./enums/FilterOptionsCalendarEnum": [
		57016,
		9
	],
	"./enums/FilterOptionsCalendarEnum.ts": [
		57016,
		9
	],
	"./enums/OptionsFilterEnum": [
		13818,
		9
	],
	"./enums/OptionsFilterEnum.tsx": [
		13818,
		9
	],
	"./enums/OptionsSendCodeEnum": [
		24111,
		9
	],
	"./enums/OptionsSendCodeEnum.ts": [
		24111,
		9
	],
	"./enums/OrderEnum": [
		69618,
		9
	],
	"./enums/OrderEnum.ts": [
		69618,
		9
	],
	"./enums/ResourcePermissionsEnum": [
		86194,
		9
	],
	"./enums/ResourcePermissionsEnum.ts": [
		86194,
		9
	],
	"./enums/ResourceRoleEnum": [
		42882,
		9
	],
	"./enums/ResourceRoleEnum.ts": [
		42882,
		9
	],
	"./enums/TransactionCodeEnum": [
		24483,
		9
	],
	"./enums/TransactionCodeEnum.ts": [
		24483,
		9
	],
	"./enums/shippinggroupEmun": [
		79531,
		9
	],
	"./enums/shippinggroupEmun.ts": [
		79531,
		9
	],
	"./helpers/FormatDateHelper": [
		15525,
		9
	],
	"./helpers/FormatDateHelper.ts": [
		15525,
		9
	],
	"./helpers/InitStateGeneral": [
		64459,
		9
	],
	"./helpers/InitStateGeneral.ts": [
		64459,
		9
	],
	"./helpers/UtilsHelper": [
		58089,
		9
	],
	"./helpers/UtilsHelper.ts": [
		58089,
		9
	],
	"./helpers/constHelper": [
		34887,
		9
	],
	"./helpers/constHelper.ts": [
		34887,
		9
	],
	"./helpers/passwordStrengthValidation": [
		69530,
		9
	],
	"./helpers/passwordStrengthValidation.ts": [
		69530,
		9
	],
	"./helpers/pdfGenerationHelper": [
		70652,
		9
	],
	"./helpers/pdfGenerationHelper.ts": [
		70652,
		9
	],
	"./helpers/validationRoutesHelper": [
		97415,
		9
	],
	"./helpers/validationRoutesHelper.ts": [
		97415,
		9
	],
	"./helpers/websiteHelper": [
		54701,
		9
	],
	"./helpers/websiteHelper.ts": [
		54701,
		9
	],
	"./hoc/OrderDetailHOC": [
		750,
		9
	],
	"./hoc/OrderDetailHOC.tsx": [
		750,
		9
	],
	"./hooks": [
		77289,
		9
	],
	"./hooks/": [
		77289,
		9
	],
	"./hooks/Media/useFormConfig": [
		59639,
		9
	],
	"./hooks/Media/useFormConfig.tsx": [
		59639,
		9
	],
	"./hooks/UseCancelDecreaseOrder": [
		81638,
		9
	],
	"./hooks/UseCancelDecreaseOrder.ts": [
		81638,
		9
	],
	"./hooks/UseCancelOrder": [
		37450,
		9
	],
	"./hooks/UseCancelOrder.ts": [
		37450,
		9
	],
	"./hooks/UseCancelToken": [
		99807,
		9
	],
	"./hooks/UseCancelToken.ts": [
		99807,
		9
	],
	"./hooks/UseCustomerRejectOrder": [
		77761,
		9
	],
	"./hooks/UseCustomerRejectOrder.ts": [
		77761,
		9
	],
	"./hooks/UseDeliveredRejectOrder": [
		60887,
		9
	],
	"./hooks/UseDeliveredRejectOrder.ts": [
		60887,
		9
	],
	"./hooks/UseDeliveredReturnOrder": [
		76520,
		9
	],
	"./hooks/UseDeliveredReturnOrder.ts": [
		76520,
		9
	],
	"./hooks/UseFilterShippingType": [
		16222,
		9
	],
	"./hooks/UseFilterShippingType.ts": [
		16222,
		9
	],
	"./hooks/UseGetMenuUser": [
		81472,
		9
	],
	"./hooks/UseGetMenuUser.ts": [
		81472,
		9
	],
	"./hooks/UseGetMultiClient": [
		87788,
		9
	],
	"./hooks/UseGetMultiClient.ts": [
		87788,
		9
	],
	"./hooks/UseGetOrderDetail": [
		74923,
		9
	],
	"./hooks/UseGetOrderDetail.ts": [
		74923,
		9
	],
	"./hooks/UseGetScheduleOrder": [
		22905,
		9
	],
	"./hooks/UseGetScheduleOrder.ts": [
		22905,
		9
	],
	"./hooks/UseGetTicketOrder": [
		21714,
		9
	],
	"./hooks/UseGetTicketOrder.ts": [
		21714,
		9
	],
	"./hooks/UseGetUserById": [
		18883,
		9
	],
	"./hooks/UseGetUserById.ts": [
		18883,
		9
	],
	"./hooks/UseGroupedOrderByCount": [
		26406,
		9
	],
	"./hooks/UseGroupedOrderByCount.ts": [
		26406,
		9
	],
	"./hooks/UseHideActionButtons": [
		57623,
		9
	],
	"./hooks/UseHideActionButtons.ts": [
		57623,
		9
	],
	"./hooks/UseListRoles": [
		54585,
		9
	],
	"./hooks/UseListRoles.ts": [
		54585,
		9
	],
	"./hooks/UseListSourcesOSRM": [
		98177,
		9
	],
	"./hooks/UseListSourcesOSRM.ts": [
		98177,
		9
	],
	"./hooks/UseListUsers": [
		91220,
		9
	],
	"./hooks/UseListUsers.ts": [
		91220,
		9
	],
	"./hooks/UseLogin": [
		28141,
		9
	],
	"./hooks/UseLogin.ts": [
		28141,
		9
	],
	"./hooks/UseManifest": [
		65499,
		9
	],
	"./hooks/UseManifest.ts": [
		65499,
		9
	],
	"./hooks/UseParentContainer": [
		6027,
		9
	],
	"./hooks/UseParentContainer.ts": [
		6027,
		9
	],
	"./hooks/UseScanner": [
		43758,
		9,
		11749,
		43758
	],
	"./hooks/UseScanner.ts": [
		43758,
		9,
		11749,
		43758
	],
	"./hooks/UseSendCode": [
		36889,
		9
	],
	"./hooks/UseSendCode.ts": [
		36889,
		9
	],
	"./hooks/UseShippingGroupTraces": [
		90303,
		9
	],
	"./hooks/UseShippingGroupTraces.ts": [
		90303,
		9
	],
	"./hooks/UseTransfer": [
		50877,
		9
	],
	"./hooks/UseTransfer.ts": [
		50877,
		9
	],
	"./hooks/UseUpdateCourierDelivery": [
		6228,
		9
	],
	"./hooks/UseUpdateCourierDelivery.ts": [
		6228,
		9
	],
	"./hooks/UseUserPermissions": [
		62025,
		9
	],
	"./hooks/UseUserPermissions.ts": [
		62025,
		9
	],
	"./hooks/UseValidateSeriesItem": [
		86318,
		9,
		86318
	],
	"./hooks/UseValidateSeriesItem.tsx": [
		86318,
		9,
		86318
	],
	"./hooks/UseViewPickupCode": [
		93346,
		9
	],
	"./hooks/UseViewPickupCode.ts": [
		93346,
		9
	],
	"./hooks/UseViewUploadFiles": [
		40359,
		9
	],
	"./hooks/UseViewUploadFiles.ts": [
		40359,
		9
	],
	"./hooks/core/useEnv": [
		5985,
		9
	],
	"./hooks/core/useEnv.tsx": [
		5985,
		9
	],
	"./hooks/core/useMulticlient": [
		89546,
		9
	],
	"./hooks/core/useMulticlient.tsx": [
		89546,
		9
	],
	"./hooks/index": [
		77289,
		9
	],
	"./hooks/index.ts": [
		77289,
		9
	],
	"./hooks/useComponentVisible": [
		89845,
		9
	],
	"./hooks/useComponentVisible.ts": [
		89845,
		9
	],
	"./hooks/useGetOrderByStatus": [
		34929,
		9,
		34929
	],
	"./hooks/useGetOrderByStatus.ts": [
		34929,
		9,
		34929
	],
	"./hooks/useGetSgsByStatus": [
		61333,
		9
	],
	"./hooks/useGetSgsByStatus/": [
		61333,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useCore": [
		1702,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useCore.ts": [
		1702,
		9
	],
	"./hooks/useGetSgsByStatus/clients/usePrivilege": [
		16554,
		9
	],
	"./hooks/useGetSgsByStatus/clients/usePrivilege.ts": [
		16554,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useSandbox": [
		25542,
		9,
		25542
	],
	"./hooks/useGetSgsByStatus/clients/useSandbox.ts": [
		25542,
		9,
		25542
	],
	"./hooks/useGetSgsByStatus/clients/useWOM": [
		27808,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useWOM.ts": [
		27808,
		9
	],
	"./hooks/useGetSgsByStatus/index": [
		61333,
		9
	],
	"./hooks/useGetSgsByStatus/index.ts": [
		61333,
		9
	],
	"./hooks/useGetSourceInfo": [
		70561,
		9
	],
	"./hooks/useGetSourceInfo.ts": [
		70561,
		9
	],
	"./hooks/useLocalStorage": [
		75402,
		9
	],
	"./hooks/useLocalStorage.ts": [
		75402,
		9
	],
	"./hooks/useMassiveLoadOrders": [
		13047,
		9
	],
	"./hooks/useMassiveLoadOrders.ts": [
		13047,
		9
	],
	"./hooks/useOnClickOutside": [
		7708,
		9
	],
	"./hooks/useOnClickOutside.ts": [
		7708,
		9
	],
	"./hooks/useUpsertUsers": [
		31493,
		9
	],
	"./hooks/useUpsertUsers.ts": [
		31493,
		9
	],
	"./index": [
		43181,
		9
	],
	"./index.css": [
		59555,
		9,
		59555
	],
	"./index.tsx": [
		43181,
		9
	],
	"./interfaces/CommonsInterface": [
		49762,
		9,
		49762
	],
	"./interfaces/CommonsInterface.ts": [
		49762,
		9,
		49762
	],
	"./interfaces/IAlert": [
		34572,
		9,
		34572
	],
	"./interfaces/IAlert.ts": [
		34572,
		9,
		34572
	],
	"./interfaces/IAutoComplete": [
		33592,
		9,
		33592
	],
	"./interfaces/IAutoComplete.ts": [
		33592,
		9,
		33592
	],
	"./interfaces/IBarcode": [
		62218,
		9,
		62218
	],
	"./interfaces/IBarcode.ts": [
		62218,
		9,
		62218
	],
	"./interfaces/ICard": [
		3738,
		9,
		3738
	],
	"./interfaces/ICard.ts": [
		3738,
		9,
		3738
	],
	"./interfaces/ICheckbox": [
		2869,
		9,
		2869
	],
	"./interfaces/ICheckbox.ts": [
		2869,
		9,
		2869
	],
	"./interfaces/IClient": [
		29427,
		9,
		29427
	],
	"./interfaces/IClient.ts": [
		29427,
		9,
		29427
	],
	"./interfaces/ICommons": [
		2440,
		9,
		2440
	],
	"./interfaces/ICommons.ts": [
		2440,
		9,
		2440
	],
	"./interfaces/IContentCelendar": [
		48445,
		9,
		48445
	],
	"./interfaces/IContentCelendar.ts": [
		48445,
		9,
		48445
	],
	"./interfaces/IContext": [
		30505,
		9,
		30505
	],
	"./interfaces/IContext.ts": [
		30505,
		9,
		30505
	],
	"./interfaces/IContextProps": [
		78967,
		9,
		78967
	],
	"./interfaces/IContextProps.ts": [
		78967,
		9,
		78967
	],
	"./interfaces/ICustomFilters": [
		44204,
		9,
		44204
	],
	"./interfaces/ICustomFilters.ts": [
		44204,
		9,
		44204
	],
	"./interfaces/ICustomerOrder": [
		96086,
		9,
		96086
	],
	"./interfaces/ICustomerOrder.ts": [
		96086,
		9,
		96086
	],
	"./interfaces/IDateCalendar": [
		49758,
		9,
		49758
	],
	"./interfaces/IDateCalendar.ts": [
		49758,
		9,
		49758
	],
	"./interfaces/IDateRangeCalendar": [
		82861,
		9,
		82861
	],
	"./interfaces/IDateRangeCalendar.ts": [
		82861,
		9,
		82861
	],
	"./interfaces/IDocuments": [
		50344,
		9,
		50344
	],
	"./interfaces/IDocuments.ts": [
		50344,
		9,
		50344
	],
	"./interfaces/IElocker": [
		67537,
		9,
		67537
	],
	"./interfaces/IElocker.ts": [
		67537,
		9,
		67537
	],
	"./interfaces/IErrorHandler": [
		11498,
		9,
		11498
	],
	"./interfaces/IErrorHandler.ts": [
		11498,
		9,
		11498
	],
	"./interfaces/IFileCard": [
		26360,
		9,
		26360
	],
	"./interfaces/IFileCard.ts": [
		26360,
		9,
		26360
	],
	"./interfaces/IFileUpload": [
		84595,
		9,
		84595
	],
	"./interfaces/IFileUpload.ts": [
		84595,
		9,
		84595
	],
	"./interfaces/IFilterOrder": [
		96188,
		9,
		96188
	],
	"./interfaces/IFilterOrder.ts": [
		96188,
		9,
		96188
	],
	"./interfaces/IGenerateDocumentButton": [
		86514,
		9,
		86514
	],
	"./interfaces/IGenerateDocumentButton.ts": [
		86514,
		9,
		86514
	],
	"./interfaces/IGrouping": [
		92385,
		9,
		92385
	],
	"./interfaces/IGrouping.ts": [
		92385,
		9,
		92385
	],
	"./interfaces/IImage": [
		89477,
		9,
		89477
	],
	"./interfaces/IImage.tsx": [
		89477,
		9,
		89477
	],
	"./interfaces/IItemsOrder": [
		56452,
		9,
		56452
	],
	"./interfaces/IItemsOrder.ts": [
		56452,
		9,
		56452
	],
	"./interfaces/ILoginBody": [
		9619,
		9,
		9619
	],
	"./interfaces/ILoginBody.ts": [
		9619,
		9,
		9619
	],
	"./interfaces/IMenu": [
		94879,
		9,
		94879
	],
	"./interfaces/IMenu.ts": [
		94879,
		9,
		94879
	],
	"./interfaces/IModal": [
		99627,
		9,
		99627
	],
	"./interfaces/IModal.ts": [
		99627,
		9,
		99627
	],
	"./interfaces/INotification": [
		28723,
		9,
		28723
	],
	"./interfaces/INotification.ts": [
		28723,
		9,
		28723
	],
	"./interfaces/IOrder": [
		95082,
		9,
		95082
	],
	"./interfaces/IOrder.ts": [
		95082,
		9,
		95082
	],
	"./interfaces/IPage": [
		76347,
		7,
		76347
	],
	"./interfaces/IPage.ts": [
		76347,
		7,
		76347
	],
	"./interfaces/IPagination": [
		31268,
		9,
		31268
	],
	"./interfaces/IPagination.ts": [
		31268,
		9,
		31268
	],
	"./interfaces/IProcessEnv": [
		10328,
		9,
		10328
	],
	"./interfaces/IProcessEnv.ts": [
		10328,
		9,
		10328
	],
	"./interfaces/IProcessProductsList": [
		64183,
		9,
		64183
	],
	"./interfaces/IProcessProductsList.ts": [
		64183,
		9,
		64183
	],
	"./interfaces/IProductCount": [
		41430,
		9,
		41430
	],
	"./interfaces/IProductCount.ts": [
		41430,
		9,
		41430
	],
	"./interfaces/IProductDetail": [
		49288,
		9,
		49288
	],
	"./interfaces/IProductDetail.ts": [
		49288,
		9,
		49288
	],
	"./interfaces/IProductOrderDetail": [
		45136,
		9,
		45136
	],
	"./interfaces/IProductOrderDetail.ts": [
		45136,
		9,
		45136
	],
	"./interfaces/IProfileUser": [
		67900,
		9,
		67900
	],
	"./interfaces/IProfileUser.ts": [
		67900,
		9,
		67900
	],
	"./interfaces/IPropsButton": [
		39696,
		9,
		39696
	],
	"./interfaces/IPropsButton.ts": [
		39696,
		9,
		39696
	],
	"./interfaces/IPropsInput": [
		45690,
		9,
		45690
	],
	"./interfaces/IPropsInput.ts": [
		45690,
		9,
		45690
	],
	"./interfaces/IQRCode": [
		5346,
		9,
		5346
	],
	"./interfaces/IQRCode.ts": [
		5346,
		9,
		5346
	],
	"./interfaces/IRadioButton": [
		68031,
		9,
		68031
	],
	"./interfaces/IRadioButton.tsx": [
		68031,
		9,
		68031
	],
	"./interfaces/IRequestService": [
		32356,
		9,
		32356
	],
	"./interfaces/IRequestService.ts": [
		32356,
		9,
		32356
	],
	"./interfaces/IResourcePermission": [
		52999,
		9,
		52999
	],
	"./interfaces/IResourcePermission.ts": [
		52999,
		9,
		52999
	],
	"./interfaces/IResponseAttachFile": [
		75780,
		9,
		75780
	],
	"./interfaces/IResponseAttachFile.ts": [
		75780,
		9,
		75780
	],
	"./interfaces/IResponseService": [
		54376,
		9,
		54376
	],
	"./interfaces/IResponseService.ts": [
		54376,
		9,
		54376
	],
	"./interfaces/IRoute": [
		36075,
		9,
		36075
	],
	"./interfaces/IRoute.ts": [
		36075,
		9,
		36075
	],
	"./interfaces/IRulesJsonEngine": [
		91725,
		9,
		91725
	],
	"./interfaces/IRulesJsonEngine.ts": [
		91725,
		9,
		91725
	],
	"./interfaces/IScanner": [
		47688,
		9,
		47688
	],
	"./interfaces/IScanner.ts": [
		47688,
		9,
		47688
	],
	"./interfaces/IScannerInput": [
		22798,
		9,
		22798
	],
	"./interfaces/IScannerInput.ts": [
		22798,
		9,
		22798
	],
	"./interfaces/ISearchForm": [
		77782,
		9,
		77782
	],
	"./interfaces/ISearchForm.ts": [
		77782,
		9,
		77782
	],
	"./interfaces/ISearchResults": [
		48644,
		9,
		48644
	],
	"./interfaces/ISearchResults.ts": [
		48644,
		9,
		48644
	],
	"./interfaces/ISelectBox": [
		75231,
		9,
		75231
	],
	"./interfaces/ISelectBox.ts": [
		75231,
		9,
		75231
	],
	"./interfaces/ISendCode": [
		89395,
		9,
		89395
	],
	"./interfaces/ISendCode.ts": [
		89395,
		9,
		89395
	],
	"./interfaces/ISeries": [
		30173,
		9,
		30173
	],
	"./interfaces/ISeries.ts": [
		30173,
		9,
		30173
	],
	"./interfaces/IShippingGroup": [
		31935,
		9,
		31935
	],
	"./interfaces/IShippingGroup.ts": [
		31935,
		9,
		31935
	],
	"./interfaces/IShippingGroupAction": [
		52093,
		9,
		52093
	],
	"./interfaces/IShippingGroupAction.ts": [
		52093,
		9,
		52093
	],
	"./interfaces/ISkeleton": [
		2419,
		9,
		2419
	],
	"./interfaces/ISkeleton.ts": [
		2419,
		9,
		2419
	],
	"./interfaces/ISortOrders": [
		35061,
		9,
		35061
	],
	"./interfaces/ISortOrders.ts": [
		35061,
		9,
		35061
	],
	"./interfaces/ISource": [
		17213,
		9,
		17213
	],
	"./interfaces/ISource.ts": [
		17213,
		9,
		17213
	],
	"./interfaces/ITagInfoCustomer": [
		98430,
		9,
		98430
	],
	"./interfaces/ITagInfoCustomer.ts": [
		98430,
		9,
		98430
	],
	"./interfaces/ITagPrintContent": [
		12454,
		9,
		12454
	],
	"./interfaces/ITagPrintContent.ts": [
		12454,
		9,
		12454
	],
	"./interfaces/ITheme": [
		70463,
		9,
		70463
	],
	"./interfaces/ITheme.ts": [
		70463,
		9,
		70463
	],
	"./interfaces/IUser": [
		14599,
		9,
		14599
	],
	"./interfaces/IUser.ts": [
		14599,
		9,
		14599
	],
	"./interfaces/ProcessEnvInterface": [
		28096,
		9,
		28096
	],
	"./interfaces/ProcessEnvInterface.ts": [
		28096,
		9,
		28096
	],
	"./logo.svg": [
		69445,
		1,
		69445
	],
	"./mocks/get_ticket": [
		49270,
		9
	],
	"./mocks/get_ticket/": [
		49270,
		9
	],
	"./mocks/get_ticket/getTicket": [
		34391,
		3
	],
	"./mocks/get_ticket/getTicket.json": [
		34391,
		3
	],
	"./mocks/get_ticket/index": [
		49270,
		9
	],
	"./mocks/get_ticket/index.ts": [
		49270,
		9
	],
	"./overrides/layout": [
		43691,
		9
	],
	"./overrides/layout/": [
		43691,
		9
	],
	"./overrides/layout/entel": [
		93194,
		3
	],
	"./overrides/layout/entel.json": [
		93194,
		3
	],
	"./overrides/layout/entelperu": [
		1304,
		3
	],
	"./overrides/layout/entelperu.json": [
		1304,
		3
	],
	"./overrides/layout/index": [
		43691,
		9
	],
	"./overrides/layout/index.ts": [
		43691,
		9
	],
	"./overrides/layout/omnix": [
		21317,
		3
	],
	"./overrides/layout/omnix.json": [
		21317,
		3
	],
	"./overrides/layout/privilege": [
		53993,
		3
	],
	"./overrides/layout/privilege.json": [
		53993,
		3
	],
	"./overrides/layout/sandbox": [
		37729,
		3
	],
	"./overrides/layout/sandbox.json": [
		37729,
		3
	],
	"./overrides/layout/shiperto": [
		30542,
		3
	],
	"./overrides/layout/shiperto.json": [
		30542,
		3
	],
	"./overrides/layout/wom": [
		97671,
		3
	],
	"./overrides/layout/wom.json": [
		97671,
		3
	],
	"./overrides/theme/entel/Routes/List/RouteList": [
		14764,
		9
	],
	"./overrides/theme/entel/Routes/List/RouteList.tsx": [
		14764,
		9
	],
	"./overrides/theme/entel/base/components/Commons/AlertSession": [
		86376,
		9
	],
	"./overrides/theme/entel/base/components/Commons/AlertSession/": [
		86376,
		9
	],
	"./overrides/theme/entel/base/components/Commons/AlertSession/index": [
		86376,
		9
	],
	"./overrides/theme/entel/base/components/Commons/AlertSession/index.tsx": [
		86376,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateCalendar/ContentCalendar": [
		14944,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateCalendar/ContentCalendar.tsx": [
		14944,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateCalendar/DateCalendar": [
		46283,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateCalendar/DateCalendar.tsx": [
		46283,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateRangeCalendar": [
		28669,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateRangeCalendar.tsx": [
		28669,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler": [
		7800,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler.styled": [
		19887,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler.styled.ts": [
		19887,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler.tsx": [
		7800,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelGenerateDocuments": [
		4481,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelGenerateDocuments/": [
		4481,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelGenerateDocuments/index": [
		4481,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelGenerateDocuments/index.tsx": [
		4481,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch": [
		84394,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch.style": [
		49845,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch.style.ts": [
		49845,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch.tsx": [
		84394,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Loading/Loading": [
		17810,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Loading/Loading.tsx": [
		17810,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification": [
		78797,
		9,
		78797
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification.style": [
		1516,
		9,
		1516
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification.style.ts": [
		1516,
		9,
		1516
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification.tsx": [
		78797,
		9,
		78797
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Paginate": [
		52867,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Paginate.tsx": [
		52867,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Pagination.styled": [
		49371,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Pagination.styled.ts": [
		49371,
		9
	],
	"./overrides/theme/entel/base/components/Core/Carousel": [
		59363,
		9,
		59363
	],
	"./overrides/theme/entel/base/components/Core/Carousel/": [
		59363,
		9,
		59363
	],
	"./overrides/theme/entel/base/components/Core/Carousel/index": [
		59363,
		9,
		59363
	],
	"./overrides/theme/entel/base/components/Core/Carousel/index.tsx": [
		59363,
		9,
		59363
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrdeItem": [
		16955,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		16955,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrderItem.styled": [
		94816,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrderItem.styled.ts": [
		94816,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar": [
		1319,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar.tsx": [
		1319,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar": [
		84885,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style": [
		48804,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style.ts": [
		48804,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.tsx": [
		84885,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate": [
		63342,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate.style": [
		97585,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate.style.ts": [
		97585,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate.tsx": [
		63342,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/OrderList": [
		95083,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/OrderList.tsx": [
		95083,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder": [
		45026,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder.styled": [
		60201,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder.styled.ts": [
		60201,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder.tsx": [
		45026,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseCheckedPrePickingList": [
		13352,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseCheckedPrePickingList.ts": [
		13352,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseChekedOrderList": [
		15311,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseChekedOrderList.ts": [
		15311,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseConditionalsGroupOrder": [
		87073,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseConditionalsGroupOrder.ts": [
		87073,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/styles/OrderList.style": [
		63451,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/styles/OrderList.style.ts": [
		63451,
		9
	],
	"./overrides/theme/entel/base/components/Core/ProductTransition/ScannerlTransition": [
		87916,
		9,
		87916
	],
	"./overrides/theme/entel/base/components/Core/ProductTransition/ScannerlTransition.tsx": [
		87916,
		9,
		87916
	],
	"./overrides/theme/entel/base/components/Custom/ManifestoPrintButton": [
		44206,
		9
	],
	"./overrides/theme/entel/base/components/Custom/ManifestoPrintButton/": [
		44206,
		9
	],
	"./overrides/theme/entel/base/components/Custom/ManifestoPrintButton/ManifestoPrintBody": [
		40691,
		9
	],
	"./overrides/theme/entel/base/components/Custom/ManifestoPrintButton/ManifestoPrintBody.tsx": [
		40691,
		9
	],
	"./overrides/theme/entel/base/components/Custom/ManifestoPrintButton/index": [
		44206,
		9
	],
	"./overrides/theme/entel/base/components/Custom/ManifestoPrintButton/index.tsx": [
		44206,
		9
	],
	"./overrides/theme/entel/base/components/Custom/Switch/LabelSwitch.module.css": [
		85755,
		9
	],
	"./overrides/theme/entel/base/components/Custom/Switch/Switch": [
		11801,
		9
	],
	"./overrides/theme/entel/base/components/Custom/Switch/Switch.tsx": [
		11801,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/AlertDetailOptionStatus/AlertDetailOptionStatus": [
		50615,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/AlertDetailOptionStatus/AlertDetailOptionStatus.style": [
		20730,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/AlertDetailOptionStatus/AlertDetailOptionStatus.style.ts": [
		20730,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/AlertDetailOptionStatus/AlertDetailOptionStatus.tsx": [
		50615,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/ModalActions": [
		47117,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/ModalActions/": [
		47117,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/ModalActions/index": [
		47117,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/ModalActions/index.tsx": [
		47117,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/ProductOderDetail/ProductOrderDetail": [
		86465,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/ProductOderDetail/ProductOrderDetail.tsx": [
		86465,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide": [
		3442,
		9,
		3442
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide.tsx": [
		3442,
		9,
		3442
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide": [
		59398,
		9,
		59398
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide.tsx": [
		59398,
		9,
		59398
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide": [
		82853,
		9,
		82853
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide.tsx": [
		82853,
		9,
		82853
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody": [
		46285,
		9,
		46285
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody.tsx": [
		46285,
		9,
		46285
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintButton": [
		95243,
		9,
		95243
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintButton.tsx": [
		95243,
		9,
		95243
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style": [
		17511,
		9,
		17511
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style.ts": [
		17511,
		9,
		17511
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style": [
		76100,
		9,
		76100
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style.ts": [
		76100,
		9,
		76100
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchForm": [
		67479,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchForm.tsx": [
		67479,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchFormUsers": [
		61855,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchFormUsers.tsx": [
		61855,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchForm.style": [
		43861,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchForm.style.ts": [
		43861,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchFormUsers.style": [
		79523,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchFormUsers.style.ts": [
		79523,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOption/CardOption": [
		68383,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOption/CardOption.tsx": [
		68383,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOptions": [
		96119,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOptions.tsx": [
		96119,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryPopupChanges": [
		82585,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryPopupChanges/": [
		82585,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryPopupChanges/SummaryPopupChanges.style": [
		68459,
		9,
		68459
	],
	"./overrides/theme/entel/base/components/Summary/SummaryPopupChanges/SummaryPopupChanges.style.ts": [
		68459,
		9,
		68459
	],
	"./overrides/theme/entel/base/components/Summary/SummaryPopupChanges/index": [
		82585,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryPopupChanges/index.tsx": [
		82585,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Header": [
		30606,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Header.tsx": [
		30606,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/MainLayout": [
		61152,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/MainLayout.tsx": [
		61152,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Sidebar": [
		51309,
		9,
		20885,
		53721,
		51309
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Sidebar.tsx": [
		51309,
		9,
		20885,
		53721,
		51309
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Header.style": [
		72210,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Header.style.ts": [
		72210,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/MainLayout.style": [
		89136,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/MainLayout.style.ts": [
		89136,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Sidebar.style": [
		41289,
		9,
		41289
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Sidebar.style.ts": [
		41289,
		9,
		41289
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm": [
		43841,
		9,
		43841
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm.style": [
		2808,
		9,
		2808
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm.style.ts": [
		2808,
		9,
		2808
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm.tsx": [
		43841,
		9,
		43841
	],
	"./overrides/theme/entel/base/enums/OptionsFilterEnum": [
		41669,
		9
	],
	"./overrides/theme/entel/base/enums/OptionsFilterEnum.tsx": [
		41669,
		9
	],
	"./overrides/theme/entel/base/helpers/auth0_vars": [
		27612,
		9
	],
	"./overrides/theme/entel/base/helpers/auth0_vars.ts": [
		27612,
		9
	],
	"./overrides/theme/entel/base/helpers/cancel_reasons": [
		65737,
		9
	],
	"./overrides/theme/entel/base/helpers/cancel_reasons.ts": [
		65737,
		9
	],
	"./overrides/theme/entel/base/helpers/slots_helper": [
		45995,
		9
	],
	"./overrides/theme/entel/base/helpers/slots_helper.ts": [
		45995,
		9
	],
	"./overrides/theme/entel/base/helpers/status_helper": [
		39066,
		9
	],
	"./overrides/theme/entel/base/helpers/status_helper.ts": [
		39066,
		9
	],
	"./overrides/theme/entel/base/helpers/summary_status": [
		56774,
		9,
		56774
	],
	"./overrides/theme/entel/base/helpers/summary_status.ts": [
		56774,
		9,
		56774
	],
	"./overrides/theme/entel/base/hooks": [
		60924,
		9,
		60924
	],
	"./overrides/theme/entel/base/hooks/": [
		60924,
		9,
		60924
	],
	"./overrides/theme/entel/base/hooks/index": [
		60924,
		9,
		60924
	],
	"./overrides/theme/entel/base/hooks/index.ts": [
		60924,
		9,
		60924
	],
	"./overrides/theme/entel/base/hooks/useGetSgsByStatus": [
		2597,
		9,
		2597
	],
	"./overrides/theme/entel/base/hooks/useGetSgsByStatus.tsx": [
		2597,
		9,
		2597
	],
	"./overrides/theme/entel/base/hooks/useOSRM": [
		81240,
		9,
		81240
	],
	"./overrides/theme/entel/base/hooks/useOSRM.tsx": [
		81240,
		9,
		81240
	],
	"./overrides/theme/entel/base/hooks/useOrderGrouped": [
		97923,
		9,
		97923
	],
	"./overrides/theme/entel/base/hooks/useOrderGrouped.tsx": [
		97923,
		9,
		97923
	],
	"./overrides/theme/entel/base/hooks/useUpdateSGCustom": [
		46459,
		9
	],
	"./overrides/theme/entel/base/hooks/useUpdateSGCustom.ts": [
		46459,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useAlertSessionError": [
		18958,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useAlertSessionError.ts": [
		18958,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useAuth0Credentials": [
		34444,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useAuth0Credentials.ts": [
		34444,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useAuthorizer": [
		96763,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useAuthorizer.ts": [
		96763,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useCouriersResources": [
		69847,
		9,
		69847
	],
	"./overrides/theme/entel/base/hooks/v4/useCouriersResources.ts": [
		69847,
		9,
		69847
	],
	"./overrides/theme/entel/base/hooks/v4/usePickingItems": [
		74409,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePickingItems.ts": [
		74409,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareBff": [
		68562,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareBff.ts": [
		68562,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareOIM": [
		58407,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareOIM.ts": [
		58407,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareOsrm": [
		34009,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareOsrm.ts": [
		34009,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareQuery": [
		6632,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareQuery.ts": [
		6632,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareStateMachineTypes": [
		7887,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/usePostMiddlewareStateMachineTypes.ts": [
		7887,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useScheduleResources": [
		83132,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useScheduleResources.ts": [
		83132,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useSourcesResources": [
		55443,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useSourcesResources.ts": [
		55443,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useUpdateMultipleSgs": [
		25878,
		9
	],
	"./overrides/theme/entel/base/hooks/v4/useUpdateMultipleSgs.ts": [
		25878,
		9
	],
	"./overrides/theme/entel/base/pages/AdminDeliveriesSourcesScreen/AdminDeliveriesSourcesScreen": [
		89309,
		9
	],
	"./overrides/theme/entel/base/pages/AdminDeliveriesSourcesScreen/AdminDeliveriesSourcesScreen.style": [
		99996,
		9
	],
	"./overrides/theme/entel/base/pages/AdminDeliveriesSourcesScreen/AdminDeliveriesSourcesScreen.style.ts": [
		99996,
		9
	],
	"./overrides/theme/entel/base/pages/AdminDeliveriesSourcesScreen/AdminDeliveriesSourcesScreen.tsx": [
		89309,
		9
	],
	"./overrides/theme/entel/base/pages/AdminSourcesScreen/AdminSourcesScreen": [
		96441,
		9
	],
	"./overrides/theme/entel/base/pages/AdminSourcesScreen/AdminSourcesScreen.style": [
		24544,
		9
	],
	"./overrides/theme/entel/base/pages/AdminSourcesScreen/AdminSourcesScreen.style.ts": [
		24544,
		9
	],
	"./overrides/theme/entel/base/pages/AdminSourcesScreen/AdminSourcesScreen.tsx": [
		96441,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen": [
		39330,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen.style": [
		99418,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen.style.ts": [
		99418,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen.tsx": [
		39330,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/ChartsScreen": [
		21933,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/ChartsScreen.tsx": [
		21933,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/styles/ChartsScreen.style": [
		82301,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/styles/ChartsScreen.style.ts": [
		82301,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Carousel": [
		55601,
		9,
		55601
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Carousel.tsx": [
		55601,
		9,
		55601
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Item": [
		10829,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Item.tsx": [
		10829,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailModalAction": [
		64883,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailModalAction.tsx": [
		64883,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailProductList": [
		45131,
		9,
		45131
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailProductList.tsx": [
		45131,
		9,
		45131
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailProductListGrid": [
		8539,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailProductListGrid.tsx": [
		8539,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailScreen": [
		96372,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailScreen.tsx": [
		96372,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailSeriesList": [
		51663,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailSeriesList.tsx": [
		51663,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailTraces": [
		26974,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailTraces.tsx": [
		26974,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetails": [
		22317,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetails.tsx": [
		22317,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderHistorialExecuterActions": [
		92868,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderHistorialExecuterActions.tsx": [
		92868,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderInfoPrint": [
		88054,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderInfoPrint.tsx": [
		88054,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetail.style": [
		92222,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetail.style.ts": [
		92222,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style": [
		19817,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style.ts": [
		19817,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailSeriesList.style": [
		62151,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailSeriesList.style.ts": [
		62151,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashBoardScreen": [
		14393,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		14393,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardAside": [
		52709,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardAside.tsx": [
		52709,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardContent": [
		3226,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardContent.tsx": [
		3226,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style": [
		39461,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style.ts": [
		39461,
		9
	],
	"./overrides/theme/entel/base/pages/LoadScreen/LoadScreen": [
		13891,
		9
	],
	"./overrides/theme/entel/base/pages/LoadScreen/LoadScreen.style": [
		73278,
		9
	],
	"./overrides/theme/entel/base/pages/LoadScreen/LoadScreen.style.ts": [
		73278,
		9
	],
	"./overrides/theme/entel/base/pages/LoadScreen/LoadScreen.tsx": [
		13891,
		9
	],
	"./overrides/theme/entel/base/pages/LogoutScreen/LogoutScreen": [
		57627,
		9
	],
	"./overrides/theme/entel/base/pages/LogoutScreen/LogoutScreen.style": [
		50886,
		9,
		50886
	],
	"./overrides/theme/entel/base/pages/LogoutScreen/LogoutScreen.style.ts": [
		50886,
		9,
		50886
	],
	"./overrides/theme/entel/base/pages/LogoutScreen/LogoutScreen.tsx": [
		57627,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen": [
		24840,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen.style": [
		24991,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen.style.ts": [
		24991,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen.tsx": [
		24840,
		9
	],
	"./overrides/theme/entel/base/pages/ReportScreens/ReportScreen": [
		14584,
		9
	],
	"./overrides/theme/entel/base/pages/ReportScreens/ReportScreen.style": [
		26863,
		9
	],
	"./overrides/theme/entel/base/pages/ReportScreens/ReportScreen.style.ts": [
		26863,
		9
	],
	"./overrides/theme/entel/base/pages/ReportScreens/ReportScreen.tsx": [
		14584,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen": [
		83873,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen.style": [
		83992,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen.style.ts": [
		83992,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen.tsx": [
		83873,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/DetailUserScreen": [
		86892,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/DetailUserScreen.tsx": [
		86892,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/ListUsersScreen": [
		34033,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/ListUsersScreen.tsx": [
		34033,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/NewUserScreen": [
		51955,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/NewUserScreen.tsx": [
		51955,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/PermissionList": [
		58547,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/PermissionList.tsx": [
		58547,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/RolePermissionList": [
		95424,
		3
	],
	"./overrides/theme/entel/base/pages/UsersScreens/RolePermissionList.json": [
		95424,
		3
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/DetailUserScreen.style": [
		87322,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/DetailUserScreen.style.ts": [
		87322,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/ListUsersScreen.style": [
		75448,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/ListUsersScreen.style.ts": [
		75448,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/NewUserScreen.style": [
		77417,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/NewUserScreen.style.ts": [
		77417,
		9
	],
	"./overrides/theme/entel/base/services/ShippingGroupService": [
		5390,
		9
	],
	"./overrides/theme/entel/base/services/ShippingGroupService.ts": [
		5390,
		9
	],
	"./overrides/theme/entel/base/translates/cancel_reasons": [
		38438,
		3
	],
	"./overrides/theme/entel/base/translates/cancel_reasons.json": [
		38438,
		3
	],
	"./overrides/theme/entel/base/translates/translation": [
		37658,
		3
	],
	"./overrides/theme/entel/base/translates/translation.json": [
		37658,
		3
	],
	"./overrides/theme/entel/uat/hooks/v4/useAuthorizer": [
		20290,
		9,
		20290
	],
	"./overrides/theme/entel/uat/hooks/v4/useAuthorizer.ts": [
		20290,
		9,
		20290
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen": [
		48626,
		9,
		48626
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen.tsx": [
		48626,
		9,
		48626
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/PickingReducer": [
		39035,
		9,
		39035
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/PickingReducer.ts": [
		39035,
		9,
		39035
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder": [
		9223,
		9,
		9223
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder.ts": [
		9223,
		9,
		9223
	],
	"./overrides/theme/entel_old/base/Routes/List/RouteList": [
		33064,
		9,
		33064
	],
	"./overrides/theme/entel_old/base/Routes/List/RouteList.tsx": [
		33064,
		9,
		33064
	],
	"./overrides/theme/entel_old/base/components/Core/ProductTransition/ScannerlTransition": [
		91174,
		9,
		91174
	],
	"./overrides/theme/entel_old/base/components/Core/ProductTransition/ScannerlTransition.tsx": [
		91174,
		9,
		91174
	],
	"./overrides/theme/entelperu/Routes/List/RouteList": [
		66178,
		9
	],
	"./overrides/theme/entelperu/Routes/List/RouteList.tsx": [
		66178,
		9
	],
	"./overrides/theme/entelperu/base/components/Commons/LabelGenerateDocuments": [
		80495,
		9
	],
	"./overrides/theme/entelperu/base/components/Commons/LabelGenerateDocuments/": [
		80495,
		9
	],
	"./overrides/theme/entelperu/base/components/Commons/LabelGenerateDocuments/index": [
		80495,
		9
	],
	"./overrides/theme/entelperu/base/components/Commons/LabelGenerateDocuments/index.tsx": [
		80495,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/ModalActions": [
		40096,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/ModalActions/": [
		40096,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/ModalActions/index": [
		40096,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/ModalActions/index.tsx": [
		40096,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody": [
		37151,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody.tsx": [
		37151,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/TagPrintButton": [
		96637,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/TagPrintButton.tsx": [
		96637,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style": [
		60041,
		9,
		60041
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style.ts": [
		60041,
		9,
		60041
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style": [
		33698,
		9
	],
	"./overrides/theme/entelperu/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style.ts": [
		33698,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/Header": [
		71260,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/Header.tsx": [
		71260,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/MainLayout": [
		58450,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/MainLayout.tsx": [
		58450,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/Sidebar": [
		37687,
		9,
		20885,
		53721,
		37687
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/Sidebar.tsx": [
		37687,
		9,
		20885,
		53721,
		37687
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/styles/Header.style": [
		31596,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/styles/Header.style.ts": [
		31596,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/styles/MainLayout.style": [
		75670,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/styles/MainLayout.style.ts": [
		75670,
		9
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/styles/Sidebar.style": [
		63487,
		9,
		63487
	],
	"./overrides/theme/entelperu/base/components/Theme/Layout/Main/styles/Sidebar.style.ts": [
		63487,
		9,
		63487
	],
	"./overrides/theme/entelperu/base/components/User/Login/LoginForm": [
		95107,
		9,
		95107
	],
	"./overrides/theme/entelperu/base/components/User/Login/LoginForm.style": [
		50590,
		9,
		50590
	],
	"./overrides/theme/entelperu/base/components/User/Login/LoginForm.style.ts": [
		50590,
		9,
		50590
	],
	"./overrides/theme/entelperu/base/components/User/Login/LoginForm.tsx": [
		95107,
		9,
		95107
	],
	"./overrides/theme/entelperu/base/helpers/cancel_reasons": [
		37891,
		9
	],
	"./overrides/theme/entelperu/base/helpers/cancel_reasons.ts": [
		37891,
		9
	],
	"./overrides/theme/entelperu/base/helpers/status_helper": [
		56844,
		9
	],
	"./overrides/theme/entelperu/base/helpers/status_helper.ts": [
		56844,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderDetailModalAction": [
		99265,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderDetailModalAction.tsx": [
		99265,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderDetailScreen": [
		81790,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderDetailScreen.tsx": [
		81790,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderDetails": [
		66175,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderDetails.tsx": [
		66175,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderHistorialExecuterActions": [
		98258,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderHistorialExecuterActions.tsx": [
		98258,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderInfoPrint": [
		40528,
		9
	],
	"./overrides/theme/entelperu/base/pages/DetailOrderScreens/OrderInfoPrint.tsx": [
		40528,
		9
	],
	"./overrides/theme/entelperu/base/pages/ReportScreens/ReportScreen": [
		44706,
		9
	],
	"./overrides/theme/entelperu/base/pages/ReportScreens/ReportScreen.style": [
		28093,
		9,
		28093
	],
	"./overrides/theme/entelperu/base/pages/ReportScreens/ReportScreen.style.ts": [
		28093,
		9,
		28093
	],
	"./overrides/theme/entelperu/base/pages/ReportScreens/ReportScreen.tsx": [
		44706,
		9
	],
	"./overrides/theme/entelperu/base/translates/cancel_reasons": [
		95488,
		3
	],
	"./overrides/theme/entelperu/base/translates/cancel_reasons.json": [
		95488,
		3
	],
	"./overrides/theme/entelperu/base/translates/translation": [
		47883,
		3
	],
	"./overrides/theme/entelperu/base/translates/translation.json": [
		47883,
		3
	],
	"./overrides/theme/sandbox/base/Hooks/Media/useFormConfig": [
		31091,
		9
	],
	"./overrides/theme/sandbox/base/Hooks/Media/useFormConfig.tsx": [
		31091,
		9
	],
	"./overrides/theme/sandbox/base/Hooks/Order/useOrderAction": [
		35421,
		9
	],
	"./overrides/theme/sandbox/base/Hooks/Order/useOrderAction.tsx": [
		35421,
		9
	],
	"./overrides/theme/sandbox/base/Pages/DetailOrderScreens/OrderDetailScreen": [
		58609,
		9
	],
	"./overrides/theme/sandbox/base/Pages/DetailOrderScreens/OrderDetailScreen.tsx": [
		58609,
		9
	],
	"./overrides/theme/sandbox/base/Routes/List/RouteList": [
		60421,
		9
	],
	"./overrides/theme/sandbox/base/Routes/List/RouteList.tsx": [
		60421,
		9
	],
	"./overrides/theme/shiperto/Routes/List/RouteList": [
		94554,
		9
	],
	"./overrides/theme/shiperto/Routes/List/RouteList.tsx": [
		94554,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Calendar/DateRangeCalendar": [
		21955,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Calendar/DateRangeCalendar.tsx": [
		21955,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler": [
		17338,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler.styled": [
		95937,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler.styled.ts": [
		95937,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler.tsx": [
		17338,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch": [
		14328,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch.style": [
		35471,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch.style.ts": [
		35471,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch.tsx": [
		14328,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification": [
		13979,
		9,
		13979
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification.style": [
		80198,
		9,
		80198
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification.style.ts": [
		80198,
		9,
		80198
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification.tsx": [
		13979,
		9,
		13979
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Paginate": [
		38729,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Paginate.tsx": [
		38729,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Pagination.styled": [
		80473,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Pagination.styled.ts": [
		80473,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrdeItem": [
		51821,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		51821,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrderItem.styled": [
		41194,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrderItem.styled.ts": [
		41194,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar": [
		47925,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar.tsx": [
		47925,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar": [
		3703,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style": [
		34810,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style.ts": [
		34810,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.tsx": [
		3703,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate": [
		2800,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate.style": [
		79223,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate.style.ts": [
		79223,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate.tsx": [
		2800,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/OrderList": [
		18161,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/OrderList.tsx": [
		18161,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder": [
		45244,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder.styled": [
		43355,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder.styled.ts": [
		43355,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder.tsx": [
		45244,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseChekedOrderList": [
		62309,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseChekedOrderList.ts": [
		62309,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseConditionalsGroupOrder": [
		1099,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseConditionalsGroupOrder.ts": [
		1099,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/styles/OrderList.style": [
		69493,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/styles/OrderList.style.ts": [
		69493,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide": [
		48384,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide.tsx": [
		48384,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide": [
		49212,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide.tsx": [
		49212,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide": [
		56811,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide.tsx": [
		56811,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody": [
		77239,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody.tsx": [
		77239,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintButton": [
		76245,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintButton.tsx": [
		76245,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style": [
		65841,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style.ts": [
		65841,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style": [
		67594,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style.ts": [
		67594,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchForm": [
		51173,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchForm.tsx": [
		51173,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchFormUsers": [
		66573,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchFormUsers.tsx": [
		66573,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchForm.style": [
		88327,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchForm.style.ts": [
		88327,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchFormUsers.style": [
		16669,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchFormUsers.style.ts": [
		16669,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOption/CardOption": [
		76036,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOption/CardOption.tsx": [
		76036,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOptions": [
		4561,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOptions.tsx": [
		4561,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Header": [
		25759,
		9,
		25759
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Header.tsx": [
		25759,
		9,
		25759
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/MainLayout": [
		80826,
		9,
		20885,
		62002,
		80826
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/MainLayout.tsx": [
		80826,
		9,
		20885,
		62002,
		80826
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Sidebar": [
		62002,
		9,
		20885,
		62002
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Sidebar.tsx": [
		62002,
		9,
		20885,
		62002
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Header.style": [
		80948,
		9,
		80948
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Header.style.ts": [
		80948,
		9,
		80948
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/MainLayout.style": [
		70478,
		9,
		70478
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/MainLayout.style.ts": [
		70478,
		9,
		70478
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Sidebar.style": [
		99383,
		9,
		99383
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Sidebar.style.ts": [
		99383,
		9,
		99383
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm": [
		73175,
		9,
		73175
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm.style": [
		80166,
		9,
		80166
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm.style.ts": [
		80166,
		9,
		80166
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm.tsx": [
		73175,
		9,
		73175
	],
	"./overrides/theme/shiperto/base/hooks": [
		8810,
		9
	],
	"./overrides/theme/shiperto/base/hooks/": [
		8810,
		9
	],
	"./overrides/theme/shiperto/base/hooks/index": [
		8810,
		9
	],
	"./overrides/theme/shiperto/base/hooks/index.ts": [
		8810,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useGetSgsByStatus": [
		9227,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useGetSgsByStatus.tsx": [
		9227,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useOSRM": [
		25646,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useOSRM.tsx": [
		25646,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useOrderGrouped": [
		2917,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useOrderGrouped.tsx": [
		2917,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useUpdateSGCustom": [
		62373,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useUpdateSGCustom.ts": [
		62373,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen": [
		34816,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen.style": [
		13056,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen.style.ts": [
		13056,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen.tsx": [
		34816,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/ChartsScreen": [
		95711,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/ChartsScreen.tsx": [
		95711,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/styles/ChartsScreen.style": [
		71947,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/styles/ChartsScreen.style.ts": [
		71947,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Carousel": [
		23283,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Carousel.tsx": [
		23283,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Item": [
		43459,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Item.tsx": [
		43459,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailModalAction": [
		96169,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailModalAction.tsx": [
		96169,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailProductList": [
		21905,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailProductList.tsx": [
		21905,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailScreen": [
		41958,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailScreen.tsx": [
		41958,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailTraces": [
		4068,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailTraces.tsx": [
		4068,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetails": [
		90023,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetails.tsx": [
		90023,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderInfoPrint": [
		17512,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderInfoPrint.tsx": [
		17512,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetail.style": [
		6740,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetail.style.ts": [
		6740,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style": [
		43555,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style.ts": [
		43555,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashBoardScreen": [
		59183,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		59183,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardAside": [
		14459,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardAside.tsx": [
		14459,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardContent": [
		54164,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardContent.tsx": [
		54164,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style": [
		75759,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style.ts": [
		75759,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen": [
		97690,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen.style": [
		45189,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen.style.ts": [
		45189,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen.tsx": [
		97690,
		9
	],
	"./overrides/theme/shiperto/base/pages/ReportScreens/ReportScreen": [
		9802,
		9
	],
	"./overrides/theme/shiperto/base/pages/ReportScreens/ReportScreen.tsx": [
		9802,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen": [
		65736,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen.style": [
		40294,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen.style.ts": [
		40294,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen.tsx": [
		65736,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/DetailUserScreen": [
		76558,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/DetailUserScreen.tsx": [
		76558,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/ListUsersScreen": [
		29925,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/ListUsersScreen.tsx": [
		29925,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/NewUserScreen": [
		4073,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/NewUserScreen.tsx": [
		4073,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/PermissionList": [
		41261,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/PermissionList.tsx": [
		41261,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/RolePermissionList": [
		13706,
		3
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/RolePermissionList.json": [
		13706,
		3
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/DetailUserScreen.style": [
		86224,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/DetailUserScreen.style.ts": [
		86224,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/ListUsersScreen.style": [
		70562,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/ListUsersScreen.style.ts": [
		70562,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/NewUserScreen.style": [
		27211,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/NewUserScreen.style.ts": [
		27211,
		9
	],
	"./overrides/theme/shiperto/base/services/ShippingGroupService": [
		77772,
		9
	],
	"./overrides/theme/shiperto/base/services/ShippingGroupService.ts": [
		77772,
		9
	],
	"./overrides/theme/shiperto/base/translates/translation": [
		28163,
		3
	],
	"./overrides/theme/shiperto/base/translates/translation.json": [
		28163,
		3
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Closed/ClosedScreen": [
		6763,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Closed/ClosedScreen.tsx": [
		6763,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen": [
		61021,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen.tsx": [
		61021,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder": [
		79368,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder.ts": [
		79368,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivered/DeliveredSreen": [
		68744,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivered/DeliveredSreen.tsx": [
		68744,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivery/DeliveryScreen": [
		47343,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivery/DeliveryScreen.tsx": [
		47343,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Package/PackageScreen": [
		94521,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Package/PackageScreen.tsx": [
		94521,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Pickup/PickupScreen": [
		4675,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Pickup/PickupScreen.tsx": [
		4675,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Transit/TransitScreen": [
		5997,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Transit/TransitScreen.tsx": [
		5997,
		9
	],
	"./overrides/theme/wom/base/Pages/HomeScreens/HomeScreen/DashBoardScreen": [
		87258,
		9
	],
	"./overrides/theme/wom/base/Pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		87258,
		9
	],
	"./overrides/theme/wom/base/Pages/OrderScreens/OrderScreen": [
		41491,
		9
	],
	"./overrides/theme/wom/base/Pages/OrderScreens/OrderScreen.tsx": [
		41491,
		9
	],
	"./overrides/theme/wom/base/Pages/SearchResults/SearchResultsScreen": [
		89400,
		9
	],
	"./overrides/theme/wom/base/Pages/SearchResults/SearchResultsScreen.tsx": [
		89400,
		9
	],
	"./overrides/theme/wom/base/assets/Data/FiltersData": [
		66430,
		9
	],
	"./overrides/theme/wom/base/assets/Data/FiltersData.ts": [
		66430,
		9
	],
	"./overrides/theme/wom/base/assets/Data/ParentContainerData": [
		39026,
		9
	],
	"./overrides/theme/wom/base/assets/Data/ParentContainerData.ts": [
		39026,
		9
	],
	"./overrides/theme/wom/base/components/Commons/SelectBox/SelectBox": [
		10369,
		9
	],
	"./overrides/theme/wom/base/components/Commons/SelectBox/SelectBox.tsx": [
		10369,
		9
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FileCard": [
		79797,
		9,
		79797
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FileCard.tsx": [
		79797,
		9,
		79797
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FilesList": [
		16180,
		9,
		16180
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FilesList.tsx": [
		16180,
		9,
		16180
	],
	"./overrides/theme/wom/base/components/Core/Order/CardOrder/CardOrdeItem": [
		54060,
		9
	],
	"./overrides/theme/wom/base/components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		54060,
		9
	],
	"./overrides/theme/wom/base/components/Core/Order/OrderList": [
		67734,
		9
	],
	"./overrides/theme/wom/base/components/Core/Order/OrderList.tsx": [
		67734,
		9
	],
	"./overrides/theme/wom/base/components/OrderDetail/TransitProductOrder/TransitAction": [
		76977,
		9
	],
	"./overrides/theme/wom/base/components/OrderDetail/TransitProductOrder/TransitAction.tsx": [
		76977,
		9
	],
	"./overrides/theme/wom/base/components/SearchForm/SearchForm": [
		1560,
		9
	],
	"./overrides/theme/wom/base/components/SearchForm/SearchForm.tsx": [
		1560,
		9
	],
	"./overrides/theme/wom/base/components/Theme/Header/Header": [
		68160,
		9
	],
	"./overrides/theme/wom/base/components/Theme/Header/Header.tsx": [
		68160,
		9
	],
	"./overrides/theme/wom/base/components/User/Login/Logo": [
		8400,
		9,
		8400
	],
	"./overrides/theme/wom/base/components/User/Login/Logo.tsx": [
		8400,
		9,
		8400
	],
	"./overrides/theme/wom/base/hooks/UseGetMenuUser": [
		2194,
		9
	],
	"./overrides/theme/wom/base/hooks/UseGetMenuUser.ts": [
		2194,
		9
	],
	"./overrides/theme/wom/base/hooks/UseGroupedOrderByCount": [
		25176,
		9
	],
	"./overrides/theme/wom/base/hooks/UseGroupedOrderByCount.ts": [
		25176,
		9
	],
	"./overrides/theme/wom/base/routes/List/RouteList": [
		77895,
		9
	],
	"./overrides/theme/wom/base/routes/List/RouteList.tsx": [
		77895,
		9
	],
	"./pages/DetailOrderScreens/Canceled/CanceledScreen": [
		6051,
		9
	],
	"./pages/DetailOrderScreens/Canceled/CanceledScreen.tsx": [
		6051,
		9
	],
	"./pages/DetailOrderScreens/Closed/ClosedScreen": [
		14945,
		9
	],
	"./pages/DetailOrderScreens/Closed/ClosedScreen.tsx": [
		14945,
		9
	],
	"./pages/DetailOrderScreens/Closed/UseClosedOrder": [
		62566,
		9
	],
	"./pages/DetailOrderScreens/Closed/UseClosedOrder.ts": [
		62566,
		9
	],
	"./pages/DetailOrderScreens/Confirm/ConfirmOrderScreen": [
		13627,
		9
	],
	"./pages/DetailOrderScreens/Confirm/ConfirmOrderScreen.tsx": [
		13627,
		9
	],
	"./pages/DetailOrderScreens/Confirm/PickingReducer": [
		16972,
		9
	],
	"./pages/DetailOrderScreens/Confirm/PickingReducer.ts": [
		16972,
		9
	],
	"./pages/DetailOrderScreens/Confirm/UseConfirmOrder": [
		32098,
		9
	],
	"./pages/DetailOrderScreens/Confirm/UseConfirmOrder.ts": [
		32098,
		9
	],
	"./pages/DetailOrderScreens/Custom/OrderDetailScreen": [
		93367,
		9
	],
	"./pages/DetailOrderScreens/Custom/OrderDetailScreen.tsx": [
		93367,
		9
	],
	"./pages/DetailOrderScreens/Delivered/DeliveredSreen": [
		16438,
		9
	],
	"./pages/DetailOrderScreens/Delivered/DeliveredSreen.tsx": [
		16438,
		9
	],
	"./pages/DetailOrderScreens/Delivered/UseDeliveredOrder": [
		35630,
		9
	],
	"./pages/DetailOrderScreens/Delivered/UseDeliveredOrder.ts": [
		35630,
		9
	],
	"./pages/DetailOrderScreens/Delivery/DeliveryScreen": [
		62069,
		9
	],
	"./pages/DetailOrderScreens/Delivery/DeliveryScreen.tsx": [
		62069,
		9
	],
	"./pages/DetailOrderScreens/Delivery/UseDeliveryOrder": [
		77550,
		9
	],
	"./pages/DetailOrderScreens/Delivery/UseDeliveryOrder.ts": [
		77550,
		9
	],
	"./pages/DetailOrderScreens/InReturn/InReturnScreen": [
		61963,
		9
	],
	"./pages/DetailOrderScreens/InReturn/InReturnScreen.tsx": [
		61963,
		9
	],
	"./pages/DetailOrderScreens/Package/PackageScreen": [
		96071,
		9
	],
	"./pages/DetailOrderScreens/Package/PackageScreen.tsx": [
		96071,
		9
	],
	"./pages/DetailOrderScreens/Package/UsePackageOrder": [
		41782,
		9
	],
	"./pages/DetailOrderScreens/Package/UsePackageOrder.tsx": [
		41782,
		9
	],
	"./pages/DetailOrderScreens/Pickup/PickupScreen": [
		68529,
		9
	],
	"./pages/DetailOrderScreens/Pickup/PickupScreen.tsx": [
		68529,
		9
	],
	"./pages/DetailOrderScreens/Pickup/UsePickupOrder": [
		83134,
		9
	],
	"./pages/DetailOrderScreens/Pickup/UsePickupOrder.ts": [
		83134,
		9
	],
	"./pages/DetailOrderScreens/Returned/ReturnedScreen": [
		2411,
		9
	],
	"./pages/DetailOrderScreens/Returned/ReturnedScreen.tsx": [
		2411,
		9
	],
	"./pages/DetailOrderScreens/Transit/TransitScreen": [
		80099,
		9
	],
	"./pages/DetailOrderScreens/Transit/TransitScreen.tsx": [
		80099,
		9
	],
	"./pages/DetailOrderScreens/Transit/UseTransitOrder": [
		93676,
		9
	],
	"./pages/DetailOrderScreens/Transit/UseTransitOrder.ts": [
		93676,
		9
	],
	"./pages/HomeScreens/HomeScreen/DashBoardScreen": [
		16332,
		9
	],
	"./pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		16332,
		9
	],
	"./pages/ManifestScreens/ManifestScreen": [
		50105,
		9
	],
	"./pages/ManifestScreens/ManifestScreen.tsx": [
		50105,
		9
	],
	"./pages/OrderScreens/OrderScreen": [
		99417,
		9
	],
	"./pages/OrderScreens/OrderScreen.tsx": [
		99417,
		9
	],
	"./pages/Report/ReportPage": [
		81113,
		9
	],
	"./pages/Report/ReportPage.tsx": [
		81113,
		9
	],
	"./pages/SearchResults/SearchResultsScreen": [
		44174,
		9
	],
	"./pages/SearchResults/SearchResultsScreen.tsx": [
		44174,
		9
	],
	"./pages/TransferScreens/TransferScreen": [
		50621,
		9
	],
	"./pages/TransferScreens/TransferScreen.tsx": [
		50621,
		9
	],
	"./pages/UserScreens/LoginScreen/LoginScreen": [
		97355,
		9
	],
	"./pages/UserScreens/LoginScreen/LoginScreen.tsx": [
		97355,
		9
	],
	"./pages/UserScreens/ProfileScreen/ProfileScreen": [
		75267,
		9
	],
	"./pages/UserScreens/ProfileScreen/ProfileScreen.tsx": [
		75267,
		9
	],
	"./react-app-env.d": [
		55059,
		7,
		55059
	],
	"./react-app-env.d.ts": [
		55059,
		7,
		55059
	],
	"./routes/AppRouter": [
		11141,
		9
	],
	"./routes/AppRouter.tsx": [
		11141,
		9
	],
	"./routes/DashboardRouter": [
		2600,
		9
	],
	"./routes/DashboardRouter.tsx": [
		2600,
		9
	],
	"./serviceWorkerRegistration": [
		42266,
		9
	],
	"./serviceWorkerRegistration.ts": [
		42266,
		9
	],
	"./services/AuthServices": [
		70813,
		9
	],
	"./services/AuthServices.ts": [
		70813,
		9
	],
	"./services/ItemsService": [
		23560,
		9
	],
	"./services/ItemsService.ts": [
		23560,
		9
	],
	"./services/ListenerServices": [
		28039,
		9
	],
	"./services/ListenerServices.ts": [
		28039,
		9
	],
	"./services/Middleware": [
		53791,
		9
	],
	"./services/Middleware.ts": [
		53791,
		9
	],
	"./services/OSM": [
		50510,
		9
	],
	"./services/OSM.ts": [
		50510,
		9
	],
	"./services/OSRM": [
		78632,
		9
	],
	"./services/OSRM.ts": [
		78632,
		9
	],
	"./services/OrderServices": [
		16067,
		9
	],
	"./services/OrderServices.ts": [
		16067,
		9
	],
	"./services/OsrmServices": [
		93872,
		9,
		93872
	],
	"./services/OsrmServices.ts": [
		93872,
		9,
		93872
	],
	"./services/ShippingGroupService": [
		68155,
		9
	],
	"./services/ShippingGroupService.ts": [
		68155,
		9
	],
	"./services/SourceService": [
		12607,
		9
	],
	"./services/SourceService.ts": [
		12607,
		9
	],
	"./setupTests": [
		35374,
		7,
		35374
	],
	"./setupTests.ts": [
		35374,
		7,
		35374
	],
	"./styled-jsx.d": [
		8281,
		9,
		8281
	],
	"./styled-jsx.d.ts": [
		8281,
		9,
		8281
	],
	"./theme/ThemeUI": [
		62531,
		9
	],
	"./theme/ThemeUI.ts": [
		62531,
		9
	],
	"./theme/assets/Data/FiltersData": [
		24286,
		9
	],
	"./theme/assets/Data/FiltersData.ts": [
		24286,
		9
	],
	"./theme/assets/Data/NoExistDeliveredData": [
		71503,
		9,
		71503
	],
	"./theme/assets/Data/NoExistDeliveredData.ts": [
		71503,
		9,
		71503
	],
	"./theme/assets/Data/RouteList": [
		4188,
		9
	],
	"./theme/assets/Data/RouteList.ts": [
		4188,
		9
	],
	"./theme/assets/Data/SendCodeOptions": [
		51194,
		9
	],
	"./theme/assets/Data/SendCodeOptions.ts": [
		51194,
		9
	],
	"./theme/assets/Data/ShippingTypeOptionsData": [
		17361,
		9
	],
	"./theme/assets/Data/ShippingTypeOptionsData.ts": [
		17361,
		9
	],
	"./theme/assets/Data/SideBarData": [
		72499,
		9
	],
	"./theme/assets/Data/SideBarData.tsx": [
		72499,
		9
	],
	"./theme/assets/Data/SummaryOptionsData": [
		95401,
		9
	],
	"./theme/assets/Data/SummaryOptionsData.tsx": [
		95401,
		9
	],
	"./theme/assets/Data/pageData": [
		35858,
		9
	],
	"./theme/assets/Data/pageData.tsx": [
		35858,
		9
	],
	"./theme/assets/img/LogosClients/wom-white.png": [
		74640,
		1,
		74640
	],
	"./theme/assets/img/LogosClients/wom.svg": [
		7442,
		1
	],
	"./theme/assets/img/bg_login.png": [
		95385,
		1,
		95385
	],
	"./theme/assets/img/ico_header_logo.svg": [
		51121,
		1,
		51121
	],
	"./theme/assets/img/javascript.png": [
		90559,
		1,
		90559
	],
	"./theme/assets/img/login_logo_omnix_white.svg": [
		27193,
		1,
		27193
	],
	"./theme/assets/img/omnix-logo.svg": [
		70075,
		1,
		70075
	],
	"./theme/assets/img/omnix.png": [
		9977,
		1,
		9977
	],
	"./theme/assets/img/tech.jpg": [
		42302,
		1,
		42302
	],
	"./theme/base/Animations": [
		15933,
		9
	],
	"./theme/base/Animations.ts": [
		15933,
		9
	],
	"./theme/base/GlobalStyled": [
		89070,
		9
	],
	"./theme/base/GlobalStyled.ts": [
		89070,
		9
	],
	"./theme/base/Mixins": [
		32540,
		9
	],
	"./theme/base/Mixins.ts": [
		32540,
		9
	],
	"./theme/base/Variables": [
		2721,
		9
	],
	"./theme/base/Variables.ts": [
		2721,
		9
	],
	"./theme/common/Alert.styled": [
		49801,
		9
	],
	"./theme/common/Alert.styled.ts": [
		49801,
		9
	],
	"./theme/common/Button.styled": [
		18269,
		9
	],
	"./theme/common/Button.styled.ts": [
		18269,
		9
	],
	"./theme/common/CardItem.styled": [
		93490,
		9
	],
	"./theme/common/CardItem.styled.ts": [
		93490,
		9
	],
	"./theme/common/CheckBox": [
		20603,
		9
	],
	"./theme/common/CheckBox.ts": [
		20603,
		9
	],
	"./theme/common/Collapsible": [
		6380,
		9,
		6380
	],
	"./theme/common/Collapsible.ts": [
		6380,
		9,
		6380
	],
	"./theme/common/ContentDetailOrderActions.styled": [
		48966,
		9
	],
	"./theme/common/ContentDetailOrderActions.styled.ts": [
		48966,
		9
	],
	"./theme/common/Grid.styled": [
		62105,
		9
	],
	"./theme/common/Grid.styled.ts": [
		62105,
		9
	],
	"./theme/common/Icon.styled": [
		40477,
		9
	],
	"./theme/common/Icon.styled.ts": [
		40477,
		9
	],
	"./theme/common/Input.styled": [
		60695,
		9
	],
	"./theme/common/Input.styled.ts": [
		60695,
		9
	],
	"./theme/common/Link.styled": [
		38889,
		9
	],
	"./theme/common/Link.styled.ts": [
		38889,
		9
	],
	"./theme/common/Manifest.styled": [
		47362,
		9
	],
	"./theme/common/Manifest.styled.ts": [
		47362,
		9
	],
	"./theme/common/Notification.styled": [
		92436,
		9
	],
	"./theme/common/Notification.styled.ts": [
		92436,
		9
	],
	"./theme/common/Paragraph.styled": [
		50785,
		9
	],
	"./theme/common/Paragraph.styled.ts": [
		50785,
		9
	],
	"./theme/common/RadioButton": [
		9071,
		9
	],
	"./theme/common/RadioButton.ts": [
		9071,
		9
	],
	"./theme/common/TimeLine": [
		52585,
		9,
		52585
	],
	"./theme/common/TimeLine.ts": [
		52585,
		9,
		52585
	],
	"./theme/common/Transfer.styled": [
		5056,
		9
	],
	"./theme/common/Transfer.styled.ts": [
		5056,
		9
	],
	"./theme/styled.d": [
		10919,
		9,
		10919
	],
	"./theme/styled.d.ts": [
		10919,
		9,
		10919
	],
	"./translates/config": [
		58982,
		9
	],
	"./translates/config.ts": [
		58982,
		9
	],
	"./translates/default/translation": [
		40080,
		3
	],
	"./translates/default/translation.json": [
		40080,
		3
	],
	"./translates/privilege/translation": [
		26778,
		3
	],
	"./translates/privilege/translation.json": [
		26778,
		3
	],
	"./translates/wom/translation": [
		61744,
		3
	],
	"./translates/wom/translation.json": [
		61744,
		3
	],
	"./types/CommonsTypes": [
		27789,
		9,
		27789
	],
	"./types/CommonsTypes.ts": [
		27789,
		9,
		27789
	],
	"./types/ContextPropType": [
		48054,
		9,
		48054
	],
	"./types/ContextPropType.ts": [
		48054,
		9,
		48054
	],
	"./types/DocumentsOrderType": [
		26236,
		9,
		26236
	],
	"./types/DocumentsOrderType.ts": [
		26236,
		9,
		26236
	],
	"./types/FilesFormType": [
		61753,
		9,
		61753
	],
	"./types/FilesFormType.ts": [
		61753,
		9,
		61753
	],
	"./types/InputPropsType": [
		57608,
		9,
		57608
	],
	"./types/InputPropsType.ts": [
		57608,
		9,
		57608
	],
	"./types/MultiClientType": [
		64390,
		9,
		64390
	],
	"./types/MultiClientType.ts": [
		64390,
		9,
		64390
	],
	"./types/OrderType": [
		79936,
		9,
		79936
	],
	"./types/OrderType.ts": [
		79936,
		9,
		79936
	],
	"./types/SourceType": [
		19139,
		9,
		19139
	],
	"./types/SourceType.ts": [
		19139,
		9,
		19139
	],
	"./types/VariantAlertType": [
		5991,
		9,
		5991
	],
	"./types/VariantAlertType.ts": [
		5991,
		9,
		5991
	],
	"./types/VariantButtonType": [
		31213,
		9,
		31213
	],
	"./types/VariantButtonType.ts": [
		31213,
		9,
		31213
	],
	"./types/VariantSpinnerType": [
		68308,
		9,
		68308
	],
	"./types/VariantSpinnerType.ts": [
		68308,
		9,
		68308
	],
	"./webapp-clients/Clients": [
		84535,
		9
	],
	"./webapp-clients/Clients.ts": [
		84535,
		9
	],
	"./webapp-clients/ENTEL": [
		79720,
		9
	],
	"./webapp-clients/ENTEL/": [
		79720,
		9
	],
	"./webapp-clients/ENTEL/index": [
		79720,
		9
	],
	"./webapp-clients/ENTEL/index.tsx": [
		79720,
		9
	],
	"./webapp-clients/PRVL": [
		11368,
		9
	],
	"./webapp-clients/PRVL/": [
		11368,
		9
	],
	"./webapp-clients/PRVL/Components/CustomFilters": [
		2529,
		9,
		2529
	],
	"./webapp-clients/PRVL/Components/CustomFilters.tsx": [
		2529,
		9,
		2529
	],
	"./webapp-clients/PRVL/Components/TagConsolidation": [
		16963,
		9,
		16963
	],
	"./webapp-clients/PRVL/Components/TagConsolidation.tsx": [
		16963,
		9,
		16963
	],
	"./webapp-clients/PRVL/Components/TagCustomOrder": [
		15868,
		9,
		15868
	],
	"./webapp-clients/PRVL/Components/TagCustomOrder.tsx": [
		15868,
		9,
		15868
	],
	"./webapp-clients/PRVL/Components/TicketOrder": [
		91367,
		9,
		91367
	],
	"./webapp-clients/PRVL/Components/TicketOrder.tsx": [
		91367,
		9,
		91367
	],
	"./webapp-clients/PRVL/index": [
		11368,
		9
	],
	"./webapp-clients/PRVL/index.tsx": [
		11368,
		9
	],
	"./webapp-clients/SDM": [
		77062,
		9
	],
	"./webapp-clients/SDM/": [
		77062,
		9
	],
	"./webapp-clients/SDM/index": [
		77062,
		9
	],
	"./webapp-clients/SDM/index.tsx": [
		77062,
		9
	],
	"./webapp-clients/Sbx": [
		34517,
		9
	],
	"./webapp-clients/Sbx/": [
		34517,
		9
	],
	"./webapp-clients/Sbx/components/TagCustomOrder": [
		18465,
		9,
		18465
	],
	"./webapp-clients/Sbx/components/TagCustomOrder.tsx": [
		18465,
		9,
		18465
	],
	"./webapp-clients/Sbx/index": [
		34517,
		9
	],
	"./webapp-clients/Sbx/index.tsx": [
		34517,
		9
	],
	"./webapp-clients/Wom": [
		98239,
		9
	],
	"./webapp-clients/Wom/": [
		98239,
		9
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/GenerateDocumentButton": [
		59853,
		9,
		59853
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/GenerateDocumentButton.tsx": [
		59853,
		9,
		59853
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/useGenerateDocument": [
		98880,
		9,
		98880
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/useGenerateDocument.ts": [
		98880,
		9,
		98880
	],
	"./webapp-clients/Wom/Components/NoExistTransit": [
		74034,
		9,
		74034
	],
	"./webapp-clients/Wom/Components/NoExistTransit/": [
		74034,
		9,
		74034
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistDelivered.styled": [
		8529,
		9,
		8529
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistDelivered.styled.ts": [
		8529,
		9,
		8529
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistTransit": [
		2807,
		9,
		2807
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistTransit.tsx": [
		2807,
		9,
		2807
	],
	"./webapp-clients/Wom/Components/NoExistTransit/index": [
		74034,
		9,
		74034
	],
	"./webapp-clients/Wom/Components/NoExistTransit/index.ts": [
		74034,
		9,
		74034
	],
	"./webapp-clients/Wom/Components/NoExistTransit/useFailedTransit": [
		17001,
		9,
		17001
	],
	"./webapp-clients/Wom/Components/NoExistTransit/useFailedTransit.ts": [
		17001,
		9,
		17001
	],
	"./webapp-clients/Wom/Components/TagCustomOrder": [
		69151,
		9,
		69151
	],
	"./webapp-clients/Wom/Components/TagCustomOrder.tsx": [
		69151,
		9,
		69151
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia": [
		69012,
		9,
		69012
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia.styled": [
		35891,
		9,
		35891
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia.styled.ts": [
		35891,
		9,
		35891
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia.tsx": [
		69012,
		9,
		69012
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/useDeleteMediaFile": [
		76755,
		9,
		76755
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/useDeleteMediaFile.ts": [
		76755,
		9,
		76755
	],
	"./webapp-clients/Wom/index": [
		98239,
		9
	],
	"./webapp-clients/Wom/index.tsx": [
		98239,
		9
	],
	"./webapp-clients/shiperto": [
		31172,
		9
	],
	"./webapp-clients/shiperto/": [
		31172,
		9
	],
	"./webapp-clients/shiperto/index": [
		31172,
		9
	],
	"./webapp-clients/shiperto/index.tsx": [
		31172,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;